  <template>
      <!-- Header -->
    <div class="animated fadeIn" style="background: white;">
                 
           <br>
            <div id="typelist">
               <b-row class="col-md-12 typelist1">           
              <b-col sm="3">
                    <label>Sub Category</label>
                    <b-form-group  
                      >
                      <b-form-select v-model="selected_subcat_id" id="selected_subcat_id" name="selected_subcat_id" @change="changesubcat(selected_subcat_id); subcatsearch(selected_subcat_id);">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="subcat_details.sub_catid" v-for="subcat_details in sub_cat_id_arr">{{ subcat_details.sub_cattitle }}</option>
                    </b-form-select>   
                    </b-form-group>  

              </b-col>
              
               <b-col sm="3">
                <label>Utility Type</label><br>
                <b-form-group >
                  
                  <b-form-select v-model="selected_utility_id" id="selected_utility_id" name="selected_utility_id" @change="utilitysearch(selected_utility_id)">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="utilitylist.utility_id" v-for="utilitylist in utility_type_arr">{{ utilitylist.utilitytype_title }}</option>
                    </b-form-select>                                
                </b-form-group>                   
              </b-col> 
              
              <b-col sm="3">
                <label>PO Type</label><br>
                <b-form-group >
                  
                  <b-form-select v-model="selected_po_id" id="selected_po_id" name="selected_po_id" @change="posearch(selected_po_id)">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="polist.po_id" v-for="polist in po_typearr">{{ polist.potype_title }}</option>
                    </b-form-select>                               
                </b-form-group>                   
              </b-col>
              <b-col sm="3" class="ipadsearch">
              <b-form-group >

              <b-input-group>
                        <b-form-input type="text" v-model="search_item" name="first name" class="form-control" placeholder="Search" aria-label="Search" style="margin-top: 29px"></b-form-input>
                        <b-input-group-append>
                          <b-button type="submit" variant="primary"  @click="thumbnailsdata()" style="margin-top: 29px"><i class="fa fa-search" aria-hidden="true" >&nbsp;&nbsp;<b></b></i></b-button>
                          <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button" style="margin-top: 29px"><i class="fa fa-refresh"></i></button>
                        </b-input-group-append>
              </b-input-group>
                    </b-form-group>
            <!-- </b-form-group> -->
              </b-col>

              
            </b-row>
            </div>
            <!-- <b-row class="col-md-12 lgtypelist">           
              <b-col sm="3">
                    <label>Sub Category</label>
                    <b-form-group  
                      >
                      <b-form-select v-model="selected_subcat_id" id="selected_subcat_id" name="selected_subcat_id" @change="changesubcat(selected_subcat_id); subcatsearch(selected_subcat_id);">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="subcat_details.sub_catid" v-for="subcat_details in sub_cat_id_arr">{{ subcat_details.sub_cattitle }}</option>
                    </b-form-select>   
                    </b-form-group>  

              </b-col>
              
               <b-col sm="3">
                <label>Utility Type</label><br>
                <b-form-group >
                  
                  <b-form-select v-model="selected_utility_id" id="selected_utility_id" name="selected_utility_id" @change="utilitysearch(selected_utility_id)">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="utilitylist.utility_id" v-for="utilitylist in utility_type_arr">{{ utilitylist.utilitytype_title }}</option>
                    </b-form-select>                                
                </b-form-group>                   
              </b-col> 
              
              <b-col sm="3">
                <label>PO Type</label><br>
                <b-form-group >
                  
                  <b-form-select v-model="selected_po_id" id="selected_po_id" name="selected_po_id" @change="posearch(selected_po_id)">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="polist.po_id" v-for="polist in po_typearr">{{ polist.potype_title }}</option>
                    </b-form-select>                               
                </b-form-group>                   
              </b-col>
              <b-col sm="3" class="ipadsearch">
              <b-form-group >

              <b-input-group>
                        <b-form-input type="text" v-model="search_item" name="first name" class="form-control" placeholder="Search" aria-label="Search" style="margin-top: 29px"></b-form-input>
                        <b-input-group-append>
                          <b-button type="submit" variant="primary"  @click="thumbnailsdata()" style="margin-top: 29px"><i class="fa fa-search" aria-hidden="true" >&nbsp;&nbsp;<b></b></i></b-button>
                          <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button" style="margin-top: 29px"><i class="fa fa-refresh"></i></button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
            
              </b-col>
         
            </b-row> -->

            
              
            <b-row class="col-md-12 lgtypelist mt-3" >

                <div class="col mx-1">

                  <b-input-group class="mt-2">          
                    <ejs-multiselect
                      id="selected_segment_id"
                      placeholder="Select Segment"
                      v-model="selected_segment_id"
                      name="selected_segment_id"
                      :fields="segementid_fields"
                      :dataSource="segmentarray_list"
                      :showSelectAll="true"
                      :class="{ input: true }"
                    >
                    </ejs-multiselect>
                  </b-input-group>

                </div>
                                  
                 <!-- <div class="col mx-1" v-if="user_type !='Admin'">
                   <label>Gender</label>
                     <b-form-group>
                       <b-form-select @change="showCollection(brand_id, selected_segment_id)"
                         v-model="selected_segment_id"
                         id="selected_segment_id"
                         name="selected_segment_id"
                         placement="Select Gender"
                       >
                         <option :value="null">--Select Gender--</option>
                         <option v-if="user_type!='Admin'" v-for="segmentlist in segmentarray_list" :value="segmentlist.segment_id" :key="segmentlist.segment_id">{{
                           segmentlist.segment_title
                         }}</option>
                        
                       </b-form-select>
                     </b-form-group>
                 </div>  -->

                  <!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
                  <div class="col mx-1">
                  <b-input-group class="mt-2">
                                
                    <ejs-multiselect
                      id="selected_collection_id"
                      placeholder="Select Season"
                      v-model="selected_collection_id"
                      name="selected_collection_id"
                      :fields="collectionid_fields"
                      :dataSource="collectionData"
                      :showSelectAll="true"
                      :class="{ input: true }"
                    >
                    </ejs-multiselect>
                  </b-input-group>

                 </div>
                 <!-- <div class="col mx-1" v-if="user_type !='Admin'">
                   <label>Season</label>
                    <b-form-group >
                       <b-form-select @change="showSubcategory(selected_collection_id)"
                         v-model="selected_collection_id"
                         id="selected_collection_id"
                         name="selected_collection_id"
                       >
                         <option :value="null">--Select Season--</option>
                         <option v-for="collection in collectionData" :value="collection.collection_id" :key="collection.collection_id">{{
                           collection.collection_title
                         }}</option>
                       </b-form-select>
                     </b-form-group>
                 </div>  -->

                 <!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
                 <div class="col mx-1">

                    <b-input-group class="mt-2">
                                  
                      <ejs-multiselect
                        id="sub_catid"
                        placeholder="Select Sub-Category"
                        v-model="sub_catid"
                        name="sub_catid"
                        :fields="subcatid_fields"
                        :dataSource="sub_cat_id_arr"
                        :showSelectAll="true"
                        :class="{ input: true }"
                      >
                      </ejs-multiselect>
                    </b-input-group>

                  </div>
                 <!-- <div class="col mx-1" v-if="user_type !='Admin'">
     
                   <label>Sub-category</label>
                      <b-form-group >
                       <b-form-select @change="getPoTypeList(sub_catid);"
                         v-model="sub_catid"
                         id="sub_catid"
                         name="sub_catid"
                       >
                         <option :value="null">--Select Sub-category--</option>
                         <option v-for="subcatarry in sub_cat_id_arr" :value="subcatarry.sub_catid" :key="subcatarry.sub_catid">{{
                           subcatarry.sub_cattitle
                         }}</option>
                       </b-form-select>
                     </b-form-group>
                 </div> -->

                  <!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  -->

                  <div class="col mx-1">
                    <b-input-group class="mt-2">
                                  
                      <ejs-multiselect
                        id="selected_po_id"
                        placeholder="Select PO Id"
                        v-model="selected_po_id"
                        name="selected_po_id"
                        :fields="poid_fields"
                        :dataSource="po_typearr"
                        :showSelectAll="true"
                        :class="{ input: true }"
                      >
                      </ejs-multiselect>
                    </b-input-group>

                  </div>
                  <!-- <div class="col mx-1" v-if="user_type !='Admin'">
                   <label>PO Type (PT)</label>
                     <b-form-group >
                     
                       <b-form-select
                         v-model="selected_po_id"
                         id="selected_po_id"
                         name="selected_po_id"
                       >
                         <option :value="null">--Select PO Type--</option>
                         <option v-for="polist in po_typearr" :value="polist.po_id" :key="polist.po_id">{{
                           polist.potype_title
                         }}</option>
                       </b-form-select>
                     </b-form-group>
                 </div>  -->
                 <div class="col mx-1">
                   <label></label>
                   <b-form-group>
                    <b-button @click="searchData(brand_id)"
                           type="submit"
                           variant="primary"
                           class="px-4 pull-left mt-2"
                           >Search</b-button
                         >
                       <button
                         class="btn btn-sm btn-primary ml-3 mt-2 px-3 pb-2"
                         v-on:click="refresh()"
                         type="button"
                       >
                         <i class="fa fa-refresh"></i>
                       </button>
                     </b-form-group>
                 </div> 
      
               </b-row> 

            <b-col sm="12" class="text-right" >
                  <button v-b-tooltip.hover title="Apply Filter" type="button"  class="btn btn-default btntypelist" @click="styledropdown" style="color: #1b8eb7;font-size: 20px;float:left">

              <i class="fa fa-filter" aria-hidden="true"></i></button>
                    <b-button type="submit" variant="primary" class="px-4 pull-right" @click="redirect()">Style List</b-button>
              </b-col><br><br>
             <!--  <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ total_design_rows }}</span></b> </p>
              </b-col> -->
            <!-- <b-row class="col-md-12 ">
              <b-col sm="1" style="margin-left: 22px;"><b-form-group label="Search" :label-cols="4" > </b-form-group>
              </b-col>
                
              <b-col sm="5"> 
              <b-form-input type="text" v-model="search_item" name="first name" class="form-control" placeholder="Search" aria-label="Search"></b-form-input>
              </b-col>

              <b-col sm="1" style="margin-left: 20px;"><b-button type="submit" variant="primary" class="px-4 pull-right" @click="thumbnailsdata()"><i class="fa fa-search" aria-hidden="true" style="margin-top: 8px;">&nbsp;&nbsp;<b>Search</b></i></b-button>
              </b-col>
            </b-row> -->
           
             <div >
              
                <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ total_design_rows }}</span></b> </p>
              </b-col>
               <b-col sm="12" >
               <!-- <b-pagination v-model="currentPage" :total-rows="total_design_rows" :per-page="perPage" first-text="First" prev-text="Prev" next-text="Next" last-text="Last"></b-pagination> -->
               <paginate
                 
                  :page-count="noofpages"
                  :page-range="10"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  active-class="active"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                  v-if="total_design_rows != 0"
                  >
                </paginate>
             </b-col>
              <!-- <b-row class="col-md-12">            -->
              <!--  <b-col sm="6" class="my-1" v-if="total_design_rows>'20'">
               <b-pagination v-model="currentPage" :total-rows="total_design_rows" :per-page="perPage" first-text="First" prev-text="Prev" next-text="Next" last-text="Last"></b-pagination>

               </b-col> -->
               <!--  <b-col sm="" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ total_design_rows }}</span></b> </p>
            </b-col> -->
             <!-- </b-row> -->

 <!-- /approve/reject flow html start -->
              <template v-if="(user_type === 'Admin') && route_status==='Designs_Pending_For_Approval'">
                <input type="checkbox"  id="checkAll" class="m-2 p-2" @click="(e)=>allDesignSeleted(e.target.checked)" v-model="checkAll"/>
                Check all

                <b-button type="button" variant="info" class="px-4 mr-2 pull-right" @click="approveDesign('rejected')" v-bind:disabled="this.selectedDesign.length > 0 ? false : true">Add to Reject</b-button>
                <b-button type="button" variant="info" class="px-4 mr-2 pull-right" @click="approveDesign('approved')" v-bind:disabled="this.selectedDesign.length > 0 ? false : true">Add to Approve</b-button>
              
              </template>
<!-- /approve/reject flow html end -->  

<!-- upload image for multiple style button start -->
      <template v-if="canUploadFiles">
        <div class="d-flex flex-flow p-1 m-1 justify-content-end">
          <b-button type="button" varaint="success" class="m-1" :disabled="this.selectedStylesForFileUpload.length > 0 ? false : true" @click="handleUploadFileBtnClick">Upload Files</b-button>
          <b-button type="button" varaint="danger" class="m-1" v-if="this.selectedStylesForFileUpload.length > 0" @click="clearSelectedStyles">Clear</b-button>
        </div>
      </template>
<!-- upload image for multiple style button end -->

              <!-- Code for Thumbnail View of Image -->
            <div class="col-md-12"  style="background-color: #c8ced3; margin-top:20px;">
              <br>
              <div class="card" :current-page="currentPage" :perPage="perPage" style="background-color: #c8ced3; ">
             <div class="card-body" style="background-color: #c8ced3;" >
                <div v-if="total_design_rows>'0'" v-for="designs in design_list.slice((currentPage-1)*perPage,(currentPage-1)*perPage+perPage)" class="col-md-3" style="float: left; margin-bottom: 50px;">
                  <!-- style="width: 310px; " -->
                  <!-- {{designs.designer_name}} -->
                   <div class="card-deck deck" >

                      <div class="card" >
                         <!----><!---->
                         <div class="card-body">
                            <!----><!---->
                            <!-- <label>Design Title : Summer Designs</label><br> -->
                            <p class="card-text">
                            
                            <div class="cardall">
                              <b-card-header header-tag="header" class="p-2 summaryheader">
                                <div class="d-flex flex-flow">
                                  <strong class="mx-auto">{{designs.design_title}} <i class="fa fa-check bg-success" v-if="designs.assigned_to != null" data-toggle="tooltip" data-placement="right" title="Style Assigned"></i></strong> 
                                  <input v-if="canUploadFiles && (designs.assigned_to == null && user_type == 'Buyer')" type="checkbox" class="mx-auto" @change="(e)=>handleFileUploadSelect(designs.style_id,designs.style_name,e.target.checked)" :key="'key'+designs.style_id">
                                   <b-dropdown v-if="(designs.operational_status == 'FH-approved' || designs.operational_status == 'TP-Uploaded' || designs.operational_status == 'Measurement Chart-Uploaded' || designs.operational_status == 'BOM-Updated') && designs.assigned_to == null && user_type == 'Buyer'"
                                      variant="link"
                                      toggle-class="text-decoration-none"
                                      no-caret
                                    >
                                    <template v-slot:button-content>
                                      <button 
                                      
                                        style="border: none;"
                                        class="btn btn-link"
                                      >
                                        <span
                                          class="cui-options icons font-1xl d-block"
                                          style=""
                                        ></span>
                                      </button>
                                    </template>
                                    <b-dropdown-item @click="assignStyle(designs)">
                                     <b-button type="submit"
                                      ><i @click="assignStyle"
                                        class="fa fa-edit"
                                        
                                        aria-hidden="true"
                                        style="color: green; margin-left: 5px;"
                                      ></i>Assign Style</b-button>
                                    </b-dropdown-item>


                                  </b-dropdown>
                                </div>
                              </b-card-header>
                               <!-- <br> -->

                              <template v-if="(user_type === 'Admin') && route_status==='Designs_Pending_For_Approval'">
                                <input type="checkbox" v-if="isAllDesignSelected===false" v-bind:value="isDesignSelected(designs.style_id)" @change="(e)=>setSelectedDesign(e.target.checked,designs.style_id)" :key="designs.style_id+1" :checked="isDesignSelected(designs.style_id)">
                                <input type="checkbox" v-if="isAllDesignSelected===true" v-model="isAllDesignSelected" :key="designs.style_id+2"> 
                                
                              </template>
                            
                               <button v-b-modal.modal-lg type="button" class="btn btn-link" @click="opendesignModal(designs.style_id,designs.brand_title,designs.segment_title,designs.collection_title,designs.style_name)" v-if="user_type=='Design_Head' || user_type=='Admin' || user_type=='Quality_Head'" style="float: right;">Show Details</button>
                               
                               <router-link :to="'/design_details/' + designs.style_id" v-if="(user_type=='Brand_Manager' || user_type=='Buyer' || user_type=='Brand_Designer' || user_type=='Fit_Technician' || user_type=='Quality_Controller' || user_type=='Quality_Executive' || user_type=='Junior_Buyer' || user_type=='PO Executive' || user_type=='Buying_Head')">
              
                                <div style="text-align: center;" v-if="designs.style_image_type=='image'" >
  
                                      <router-link :to="'/design_details/' + designs.style_id">

                                        <div style="text-align: center;">

                                          <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                                          @load="imgLoadedMethod"

                                          class="img_class" style="object-fit: cover;object-position: 0 -15%;"/>

                                          <!-- <img v-bind:src="designs.style_image" class="img_class" style=""> -->

                                        </div>

                                      </router-link>

                                    </div>
                                <!-- code for PDF -->

                                <div style="text-align: center;" v-if="designs.style_image_type=='other'" >
                                  <div id="designsimage">
                                      <vue-pdf-embed :source="designs.style_image"></vue-pdf-embed>
                                  </div>
                                </div>
                                <!-- Code for PDF Ends -->
                              </router-link>
                                <div style="text-align: center;" v-if="(user_type=='Design_Head' || user_type=='Admin' || user_type=='Quality_Head') && designs.style_image_type=='image'">

                                 <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"  @load="imgLoadedMethod" :key="designs.style_image + designs.style_id"  class="img_class" style="object-fit: cover;object-position: 0 -15%;"/>

                                  <!-- <img v-bind:src="designs.style_image" class="img_class" style=""> -->
                                  <!-- <img src="/loadersmall.gif" class="lazy img_class" :data-src="designs.style_image" :key="designs.style_image + designs.style_id"/> -->
                                </div>
                              
                               <!-- Code for PDF -->
                               <div style="text-align: center;" v-if="(user_type=='Design_Head' || user_type=='Admin' || user_type=='Quality_Head'|| user_type=='PO Executive') && designs.style_image_type=='other'" >
                                  <div id="alldesignsimage">
                                      <vue-pdf-embed :source="designs.style_image"></vue-pdf-embed>
                                  </div>
                                </div>
                               <!-- Code for PDF Ends -->
                            </div>
                            </p>

                            <!-- <label>Color : {{designs.collection_title}}</label><br> -->
                                
                       
                         <!-- <div class="card-footer"> -->
                                  <!-- <span style="float:left">
                                    {{designs.design_title}}
                                  </span> 
                      <span style="float:right">
                        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                          <template v-slot:button-content>
                            <span class="cui-options icons font-1xl d-block"></span>
                          </template>
                          <b-dropdown-item href="/designsummry">View Detail</b-dropdown-item>
                          <b-dropdown-item href="#">Send Quote</b-dropdown-item>
                          
                        </b-dropdown>

                      </span> --></div>
                      <br><br><br><br>
                      
                      <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {{designs.designer_name}}-->
                      <div  class="card-footer summaryfooter">
                       <!--  <span  data-toggle="tooltip" style="width: 100px;word-wrap: break-word;"> -->
                         <!-- <div class="tooltip"> -->
                          <label v-b-tooltip.hover :title="designs.designer_name" v-if="user_type!='Admin'">Designer Name:&nbsp;{{designs.designer_name}}</label>
                            <label  :title="designs.designer_name" v-else-if="user_type=='Admin'">Designer Name:&nbsp;{{designs.designer_name}}
                        </label>
                      <!-- </div> -->
                      <!-- </span> -->
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <!-- <b-tooltip target="button-1" title="">
                         {{designs.designer_name}}
                        </b-tooltip> {{designs.color}}-->
                     <!--  <span  data-toggle="tooltip" style="width: 100px;word-wrap: break-word;"> -->
                      <label v-b-tooltip.hover :title="designs.color" v-if="user_type!='Admin'">Color:&nbsp;{{designs.color}} </label> 
                      <label v-b-tooltip.hover :title="designs.color" v-if="user_type=='Admin'">Color:&nbsp;{{designs.color}} </label> 
                    <!-- </span> -->
                     <!--  <div class="vendor_tooltip">{{row.item.vendor_name.substring(0,22)+".." }}<span class="tooltip_text">{{row.item.vendor_name}}
                        </span>
                      </div>   -->
                                   
                      <!-- <span style="float:right">
                        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                          <template v-slot:button-content>
                            <span class="cui-options icons font-1xl d-block"></span>
                          </template>

                          
                        </b-dropdown>
                      </span> -->                          
                          
                       <!-- <div class="card-footer:col-md-12"> -->

                       
                 
                       <!-- </div> -->


                            <!-- </div> -->
                         </div>

                        
                         <!---->
                      </div>
                      
                   </div>
                   <br>
                   <!-- <br> -->

                </div>
               
         
             </div>
             <div v-if="total_design_rows=='0'" style="text-align: center;">
               <span >No Records Found</span>
             </div>
          </div>

 <!-- <b-col md="12" class="my-1" v-if="total_design_rows>'0'">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="total_design_rows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col> -->
            </div>
             <b-col md="12" class="my-1" v-if="total_design_rows>'20'">
             <!-- <b-pagination v-model="currentPage" :total-rows="total_design_rows" :per-page="perPage" first-text="First" prev-text="Prev" next-text="Next" last-text="Last"></b-pagination> -->
             <!-- <paginate
                 
                  :page-count="noofpages"
                  :page-range="10"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'">
                </paginate> -->
           </b-col>
          </div>

                         <!-- Code For Design Details Model -->
      <b-modal id="modal-lg" size="xl" title="Design Details" v-model="showdesigndetails" @ok="showdesigndetails = false">
      <b-row>
         <b-col sm="12">
          <button style="color: #1b8eb7;font-size: 12px;float:right" class="btn btn-default tablechart" @click="opentable" ><i v-b-tooltip.hover title="Measurement Chart" class="fa fa-table" aria-hidden="true"></i></button>
        </b-col>
      <b-col sm="12" class='col-md-12'>
        
       <b-form name="addSegmentForm" @submit.prevent="updatestylestatus(comment,status)" >

                 <!-- <b-row class="col-md-12">
          
        </b-row> -->
         <b-row class="col-md-12">
            
            <b-col cols="4">
               <div class="detailimgborder" v-if="style_details.style_image_type=='image'">
                <b-spinner v-if="img_path.length <= 0" variant="primary" type="grow" label="Spinning" class="detailsmodalimg"></b-spinner>
              <img v-if="img_path.length > 0" v-bind:src="img_path" alt="No Image To Show" class="detailsmodalimg" />

                  <!-- <img v-bind:src="img_path" alt="No Image To Show" class="detailsmodalimg" /> -->
                   <button v-b-modal.zoom-modal-lg type="button"  class="btn btn-success summaryzoombtn" ><i class="fa fa-search-plus" aria-hidden="true">&nbsp;Zoom Image</i></button>
                  <!-- <image-magnifier :src="img_path"
                    :zoom-src="img_path"
                    width="400"
                    height="300"
                    zoom-width="400"
                    zoom-height="300" style="padding:5px;"></image-magnifier> -->
                  <!-- <b-form-group style="margin-top:25px;">
                        
                    <b-form-group>
                        <b-col md="9">
                        </b-col>
                      <b-col md="3" class="pull-right"><img v-bind:src="img_path" height="100px" width="100px" /></b-col></b-form-group>
                    
                  </b-form-group>     -->              
               </div>
               <div  v-if="style_details.style_image_type=='other'" >
                  <div id="pdfOverride">
                      <vue-pdf-embed :source="style_details.style_image" />
                  </div>
                  <button v-b-modal.zoom-modal-lg type="button"  class="btn btn-success summaryzoombtn" ><i class="fa fa-search-plus" aria-hidden="true">&nbsp;Zoom Image</i></button>
        
                  <!-- <div style="display: flex; justify-content: center; align-items: center;">
                      <button @click="openimage"  class="btn btn-success btndesign" ><i class="fa fa-search-plus" 
                      aria-hidden="true">&nbsp;Zoom Image</i></button>
                    </div> -->
                </div>

                <div
                        class="divdesign mt-2"
                        v-if="
                          style_details.artwork_image != null &&
                            style_details.artwork_image != ''
                        "
                      >
                        <p style="text-align:center" class="mt-2">
                          Artwork Image
                        </p>
                        <img
                          v-bind:src="style_details.artwork_image"
                          class="imgdesign"
                        />
                        <p class="text-center">
                          {{ style_details.artwork_title }}
                        </p>
                        <button
                          type="button"
                          @click="openArtWorkimage"
                          class="btn btn-success btndesign mb-2"
                        >
                          <i class="fa fa-search-plus" aria-hidden="true"
                            >&nbsp;Zoom Image</i
                          >
                        </button>
                      </div>
              
                  
              

            </b-col>
             
            <b-col cols="2">
              
            </b-col>

            <b-col cols="6" class="designsummaryipad">
              
               
              <div  class='col-md-12 designsummary' >    

                <!-- <b-col md="6" class="pull-left"> -->
                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Brand Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{customer.brand_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Style Code</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.style_code}}
                   </b-col>
                  </b-form-group>

                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Story Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.story_name}}
                   </b-col>
                  </b-form-group>

                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Segment Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.segment_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Collection Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{customer.collection_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Category Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.category_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Sub Category Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.sub_cattitle}}
                   </b-col>
                  </b-form-group>

                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Style Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.style_name}}
                   </b-col>
                  </b-form-group>

                  <b-form-group class="m-0"
                          v-if="
                            style_details.artwork_created_by != null &&
                              style_details.artwork_created_by != ''
                          "
                        >
                          <b-col md="5" class="pull-left">
                            <label for="name"><b>Artwork Created By</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left colonb"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right titleb"
                            >{{ style_details.artwork_created_by }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="m-0"
                          v-if="
                            style_details.artwork_edited_by != null &&
                              style_details.artwork_edited_by != ''
                          "
                        >
                          <b-col md="5" class="pull-left">
                            <label for="name"><b>Artwork Edited By</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left colonb"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right titleb"
                            >{{ style_details.artwork_edited_by }}
                          </b-col>
                        </b-form-group>


                  <b-form-group class="m-0" v-if="style_details.sample_image != null && style_details.sample_image != ''">
                    <b-col md="5" class="pull-left">
                    <label for="name"><b>Sample Image</b></label>
                    </b-col>
                    <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                     
                    <b-col md="6" class="pull-right titleb">
                      <a :href="style_details.sample_image" target="_blank"><i class="fa fa-download" aria-hidden="true" v-b-tooltip.hover title="Click to download" style="font-size:20px;"></i></a>
                    </b-col>
                  </b-form-group>


                  
                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5" >
                     <label for="name"><b>PO Type</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.potype_title}}
                   </b-col>
                  </b-form-group>


                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5" >
                     <label for="name"><b>Utility Type</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.utilitytype_title}}
                   </b-col>
                  </b-form-group>

                   <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5" >
                     <label for="name"><b>Style Type</b></label>
                    </b-col> 
                    <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                    <b-col md="6" class="pull-right summarymodel" >{{style_details.style_type ? style_details.style_type : 'NA'}}
                    </b-col>
                  </b-form-group>

                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5" >
                     <label for="name"><b>Fabric Type</b></label>
                    </b-col> 
                    <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                    <b-col md="6" class="pull-right summarymodel" >{{style_details.fabrictype ? style_details.fabrictype : 'NA'}}
                    </b-col>
                  </b-form-group>
                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5" >
                      <label for="name"><b>Top Fabric/Upper Fabric</b></label>
                    </b-col> 
                    <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                    <b-col md="6" class="pull-right summarymodel" >{{style_details.materialinfoupperfabric ? style_details.materialinfoupperfabric : 'NA'}}
                    </b-col>
                  </b-form-group>
                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5" >
                      <label for="name"><b>Bottom Fabric/Sole Material</b></label>
                    </b-col> 
                    <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                    <b-col md="6" class="pull-right summarymodel" >{{style_details.solematerial ? style_details.solematerial : 'NA'}}
                    </b-col>
                  </b-form-group>
                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5" >
                      <label for="name"><b>Fabric Composition</b></label>
                    </b-col> 
                    <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                    <b-col md="6" class="pull-right summarymodel" >{{style_details.fabriccomposition ? style_details.fabriccomposition : 'NA'}}
                    </b-col>
                  </b-form-group>
                  <b-form-group class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5" >
                      <label for="name"><b>Sleeve Length</b></label>
                    </b-col> 
                    <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                    <b-col md="6" class="pull-right summarymodel" >{{style_details.sleevelength ? style_details.sleevelength : 'NA'}}
                    </b-col>
                  </b-form-group>

                  <b-form-group class="styleform m-0">
                    <b-col md="5" class="pull-left detailscol5">
                      <label for="name"><b>Material: </b></label>
                    </b-col>
                    <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>
  
                    <b-col md="6" class="pull-right detailscol6"
                      ><span v-if="style_details.material">{{style_details.material}}</span>
                      <span v-if="!style_details.material">NA</span>
                    </b-col>
                  </b-form-group>
                  <b-form-group class="styleform m-0">
                    <b-col md="5" class="pull-left detailscol5">
                      <label for="name"><b>Pack Of: </b></label>
                    </b-col>
                    <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>
  
                    <b-col md="6" class="pull-right detailscol6"
                      ><span v-if="style_details.pack_of">{{style_details.pack_of}}</span>
                      <span v-if="!style_details.pack_of">NA</span>
                    </b-col>
                  </b-form-group>
                  <b-form-group class="styleform m-0">
                    <b-col md="5" class="pull-left detailscol5">
                      <label for="name"><b>Epp: </b></label>
                    </b-col>
                    <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>
  
                    <b-col md="6" class="pull-right detailscol6"
                      ><span v-if="style_details.is_epp">{{style_details.is_epp}}</span>
                      <span v-if="!style_details.is_epp">NA</span>
                    </b-col>
                  </b-form-group>

                  <b-form-group class="styleform m-0">
                    <b-col md="5" class="pull-left detailscol5">
                        <label for="name"><b>Style Comment </b></label>
                    </b-col>
                    <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                    <b-col md="6" class="pull-right detailscol6"
                        ><span v-if="style_details.style_comment">{{style_details.style_comment}}</span>
                        <span v-if="!style_details.style_comment">NA</span>
                    </b-col>

                </b-form-group>

                  <b-form-group v-if="user_type=='Admin' && style_details.operational_status == 'BH-approved'" class="m-0">
                  <b-col md="5" class="pull-left designsummarycol5"  >
                    <label for="name"><b>Remark</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                  <b-col md="6" class="pull-right summarymodel" >
                  <b-form-textarea rows="3" max-rows="4" v-model="comment" type="text" name="comment"  
                  placeholder="Enter Comment Here..." >
                  </b-form-textarea>
                </b-col>
                </b-form-group>
                  <br>
                  <!-- <b-col md="5" class="pull-left designsummarycol5" >
                    
                  </b-col>
                  <b-col md="1" class="pull-left designsummarycol1"></b-col> -->
                  <b-form-group class="m-0">
                  <b-input-group  >
                  <b-col md="12" v-if="user_type=='Admin' && style_details.operational_status == 'BH-approved'">
                  
                      <label class="radio-inline pull-right summarymodel">&nbsp;&nbsp;<input type="radio" name="optradio" value="Feedback" v-model="status">&nbsp;Feedback</label>                       
                    &nbsp;&nbsp;
                    <label class="radio-inline pull-right summarymodel">&nbsp;&nbsp;<input type="radio" name="optradio" value="rejected" v-model="status">&nbsp;Reject</label>&nbsp;&nbsp;
                    <label class="radio-inline pull-right summarymodel">&nbsp;&nbsp;<input type="radio" name="optradio" value="approved" v-model="status" checked>&nbsp;Approved</label>&nbsp;&nbsp;

                  </b-col> 
                      </b-input-group>
                              
                </b-form-group>   
              </div>
            </b-col>

            <b-col cols="6" class="m-0">
               <!-- <div style="float: left;
                  border: 1px solid lightgray;"> -->
                              <!-- Added Code for Size Set -->
            

            <!-- Added Code for Size Set Ends -->          
               <!-- </div> -->

              
                  
              

            </b-col>


            <!-- <b-col cols="2"></b-col> -->

            <b-col cols="6" class="designsummaryipad m-0" >
              
               
              <div  class='col-md-12 designsummary' > 

                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>No of Size Sets</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.no_of_sizeset}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Panton Type</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.panton_type}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'" class="mt-1">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Color</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>

                   <b-col md="6" class="pull-right summarymodel">
                    <div class="mt-1" v-for="colors in selected_mutlicolor" :style="`background-color:${colors.split(' ').pop()}`">
                      {{ colors }}
                    </div>
                   </b-col>

                  </b-form-group>
                   <!-- <b-form-group v-if="selected_panton_type !='OTHERS'" class="m-0">
                    <b-col md="5" class="pull-left">
                    <label for="name"><b>Selected Color</b></label>
                    </b-col>
                    <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                     
                    <b-col md="6" class="pull-right summarymodel"><div id="showcolor" class="selectedcolor"></div>
                    </b-col>
                  </b-form-group> -->

                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Operational Status</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.operational_status}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Design Status</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.design_status}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Created By</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.full_name}}
                   </b-col>
                  </b-form-group>  

                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Designer Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.designer_name}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Fit Tech Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.fit_tech_name}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Buyer Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.buyer_name}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Created Date</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.created_date}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Updated Date</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.updated_date}}
                   </b-col>
                  </b-form-group>

                  <b-form-group v-if="user_type!='Admin'" class="m-0">
                    <b-col md="5" class="pull-left designsummarycol5">
                     <label for="name"><b>Style Description</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left designsummarycol1"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right summarymodel" >{{style_details.style_description}}
                   </b-col>
                  </b-form-group>

                </div>  
               
            </b-col>
         </b-row>
         <b-row>
             <div  class="col-md-12 tablemd" id="tablesm">
              
              <!-- <b-row> -->
            <b-form  >
            <table class="table table-striped">
            <thead>
              <tr>
                <td scope="col" style="width: 10%">Size Set</td>                
                <td scope="col" style="width: 20%">Unit</td>
                <td scope="col" style="width: 15%">Age From</td>
                <td scope="col" style="width: 15%">Age To</td>
                <td scope="col" style="width: 17%">Factory Size(In CM / In Inch)</td>
                <td scope="col" style="width: 17%">Quantity</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(invoice_product, index) in sizeset">
                <td ><label>Size &nbsp;</label>{{index+1}}</td>
                
                <td>
                    <b-form-select :plain="true" name="selected_month" required v-model="selected_month[index]" :options="unit_arr"  @change="changeMonthYearVal($event,index)" disabled readonly >
                    </b-form-select>
                    
                </td>

                <td>
                  <b-form-select  :plain="true" name="selectedfromage"  v-model="selectedfromage[index]" required :options="month_arr" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }"  disabled readonly>
                  </b-form-select>

                               
                </td>
                
                <td > 

                  <b-form-select    :plain="true" v-model="selectedtoage[index]" :options="to_month_arr"  required @change="checkagevalue(selectedfromage[index],selectedtoage[index], index)" disabled readonly>
                  </b-form-select> 

                </td>

                <td >
                  <b-form-input type="text" name="factorysize"   v-model="factorysize[index]" :key="index"  required disabled readonly></b-form-input>
                </td>

                <td >
                  <!-- @change="calculateTotalQuantity(selectedfromage[index],selectedtoage[index],index)" -->
                  <b-form-input type="text" name="quantity"   v-model="quantity[index]" :key="index"  required disabled readonly></b-form-input>
                </td>
              </tr>
            </tbody>
          </table>
                </b-form>
                  <!-- </b-row> -->
                    
            </div>
          </b-row>
          
                    
                

              <!-- </div> -->
            
            <div slot="footer"  style="margin-top:20px;text-align:right" v-if="(style_details.operational_status=='StyleNoCreated' || style_details.operational_status=='BH-approved') 
            && (user_type!='Buyer' || user_type!='Admin')">
            
              <b-form-group
                  label="Remark"
                  :label-cols="3" v-if="user_type!='Admin'">
                  <b-form-textarea rows="3" max-rows="6" v-model="comment" type="text" name="comment"  
                  placeholder="Enter Comment Here...">
                  </b-form-textarea><br>
                  <b-input-group class="mb-3">
                      <label class="radio-inline"><input type="radio" name="optradio" value="approved" v-model="status" @click="selectGrade()" checked>&nbsp;Approved</label>&nbsp;&nbsp;
                      <label class="radio-inline"><input type="radio" name="optradio" value="rejected" v-model="status">&nbsp;Reject</label>&nbsp;&nbsp;

                      <label class="radio-inline"><input type="radio" name="optradio" value="Feedback" v-model="status">&nbsp;Feedback</label>                       
                    &nbsp;&nbsp;
                      </b-input-group>
                                 
                </b-form-group>

                
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update Status</b-button>
                  <b-button  size="sm" variant="danger" @click="commentcancel()">cancel</b-button>
                </div>

            </div>
         </b-form>
      </b-col>

    </b-row>

    </b-modal>

       <b-modal  size="xl" title="Table Set" v-model="opentablemodel" @ok="opentablemodel = false">
          <template slot="modal-header">
          <h5>Measurement Chart</h5>
        </template>
            <!-- <template slot="default" slot-scope="{ hide }">
            <div>
              Hiiiiiiiiii
            </div>
          </template> -->
          <!-- <b-button  size="sm"  @click="openimagecancel()" style="background: none; border: none;"><i class="fa fa-close"></i></b-button>
          </template> -->
          <template slot="default">
         <!--    <div>
              <span style="color:red;padding:10px"><b>N.B&nbsp;:</b>&nbsp;M- Month & Y- Year</span>
            </div> -->
            <b-row style="overflow:auto">
                <b-form  >
                  <table class="table table-striped">
            <thead>
              <tr>
                <td scope="col" class="sumtdhset" >Size Set</td>                
                <td scope="col" class="sumtdhunit">Unit</td>
                <td scope="col" class="sumtdhagefrom">Age From</td>
                <td scope="col" class="sumtdhageto">Age To</td>
                <td scope="col" class="sumtdhsize">Factory Size(In CM / In Inch)</td>
                <td scope="col" class="sumtdhquantity">Quantity</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(invoice_product, index) in sizeset">
                <td ><label class="sumtdbset">Size &nbsp;{{index+1}}</label></td>
                
                <td>
                    <b-form-select class="sumtdbunit" :plain="true" name="selected_month" required v-model="selected_month[index]" :options="unit_arr"  @change="changeMonthYearVal($event,index)" disabled readonly >
                    </b-form-select>
                    
                </td>

                <td>
                  <b-form-select class="sumtdbfage" :plain="true" name="selectedfromage"  v-model="selectedfromage[index]" required :options="month_arr" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }"  disabled readonly>
                  </b-form-select>

                               
                </td>
                
                <td > 

                  <b-form-select class="sumtdbtage"   :plain="true" v-model="selectedtoage[index]" :options="to_month_arr"  required @change="checkagevalue(selectedfromage[index],selectedtoage[index], index)" disabled readonly>
                  </b-form-select> 

                </td>

                <td >
                  <b-form-input class="sumtdbsize" type="text" name="factorysize"   v-model="factorysize[index]" :key="index"  required disabled readonly></b-form-input>
                </td>

                <td >
                  <!-- @change="calculateTotalQuantity(selectedfromage[index],selectedtoage[index],index)" -->
                  <b-form-input class="sumtdbquantity" type="text" name="quantity"   v-model="quantity[index]" :key="index"  required disabled readonly></b-form-input>
                </td>
              </tr>
            </tbody>
          </table>
                </b-form>
                  </b-row>
       <div slot="footer" class="text-right">
                 <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
                  <b-button  size="sm" variant="danger" @click="opentablecancel()">cancel</b-button>
                </div>
          </template>
              
          <template slot="modal-footer" slot-scope="{ hide }">
            
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            
          </template>
      </b-modal> 
             <!-- Code For Design Details Ends -->
                   <!-- Image Zoom Model -->
    <b-modal id="zoom-modal-lg" size="lg" title="Image Zoom" v-model="openimagemodel" @ok="openimagemodel = false">
          <template slot="modal-header">
          <h5>Zoom Image</h5>
          <!-- <button type="button" class="close" aria-label="Close"  slot-scope="{ hide }">
            <span aria-hidden="true">&times;</span>
          </button> -->
          <b-button  size="sm"  @click="openimagecancel()" style="background: none; border: none;"><i class="fa fa-close"></i></b-button>
          </template>
          <template slot="default" slot-scope="{ hide }">
            <div id="btn_navbar">
              <button type="button" class="btn btn-success" @click="zoomin()"><i class="fa fa-search-plus" aria-hidden="true">&nbsp;Zoom In</i></button>&nbsp;
              <button type="button" class="btn btn-danger" @click="zoomout()"><i class="fa fa-search-minus" aria-hidden="true">&nbsp;Zoom Out</i></button>
              </div>

              <div class="main1" style="text-align: center;">
              <!-- <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;"/> -->

              <div v-if="style_details.style_image_type=='image'">
                  <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;"/>
                </div>
              <div  v-if="style_details.style_image_type=='other'" >
                <vue-pdf-embed :source="style_details.style_image" id="map" height="220" width="270" style="padding:5px;" ></vue-pdf-embed>
              </div>

              </div>


            

                <div slot="footer" class="text-right">
                 <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
                  <b-button  size="sm" variant="danger" @click="openimagecancel()">cancel</b-button>
                </div>

          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            
          </template>
      </b-modal> 
            <!-- Image Zoom Model -->

      <!-- multiple file upload modal -->
          <b-modal id="fileUploadModal" title="List of Selected Styles for File Upload" size="xl" @hide="handleFileUploadModalClose">
            <table class="table table-bordered border-dark" :aria-hidden="showLoader ? 'true' : null">
              <tr>
                <th >ID</th>
                <th >BOM</th>
                <th >Techpack</th>
                <th >Measurement Chart</th>
              </tr>
              <tr v-for="item in selectedStylesForFileUpload">
                <td>{{item.style_name}}</td>
                <td>
                  <div class="d-flex flex-flow">
                    <input type='file' class='form-control' @change="(e)=>handleFileUpload(e.target.files[0],item.style_id,'BOM')"/> 
                    <i class='fa fa-check fa-2x' style="color:green;display:none;" :id="'isUploadedBOM'+item.style_id"></i> 
                    <a href="#" :id="'downloadLinkBOM'+item.style_id" download style="display:none;"><i class='fa fa-download fa-2x' style="color:darkslategray;"></i></a>
                    </div>
                </td>
                <td>
                  <div class="d-flex flex-flow">
                    <input type='file' class='form-control' @change="(e)=>handleFileUpload(e.target.files[0],item.style_id,'Techpack')"/> 
                    <i class='fa fa-check fa-2x' style="color:green;display:none;" :id="'isUploadedTechpack'+item.style_id"></i> 
                    <a href="#" :id="'downloadLinkTechpack'+item.style_id" download style="display:none;"><i class='fa fa-download fa-2x' style="color:darkslategray;"></i></a>
                  </div>
                </td>
                <td>
                  <div class="d-flex flex-flow">
                    <input type='file' class='form-control' @change="(e)=>handleFileUpload(e.target.files[0],item.style_id,'Measurement Chart')"/> 
                    <i class='fa fa-check fa-2x' style="color:green;display:none;" :id="'isUploadedMeasurementChart'+item.style_id"></i>
                    <a href="#" :id="'downloadLinkMeasurementChart'+item.style_id" download style="display:none;"><i class='fa fa-download fa-2x' style="color:darkslategray;"></i></a>
                  </div>
                </td>
              </tr>
            </table>
            <b-form-group>
              <span v-b-modal.modal-bom  @click="showBomModal" class="text-primary" style="cursor: pointer;"> 
                Download Sample BOM File
              </span>
            </b-form-group>
          </b-modal>
           <div id="fileUploadOverlay" style="display:none;">
                <div class="fileUploadLoader"></div>
            </div>
              <!-- ~~~~~~~~~~~Modal for BOM Template -->
           <div>
            <b-modal id="modal-bom" hide-footer  size="lg" title="BOM Templates">
                
                    <div class="card">
                      <div class="card-body pl-3 pr-3">

                       
                          
                          <b-table class="mt-4" caption-top show-empty stacked="md" :busy="isBusy"  :items="items2"  :fields="fields3"  :current-page="currentPageBom" :perPage="perPageBom" :bordered="true">
                          <!-- <b-table class="mt-4" caption-top show-empty stacked="md" :busy="isBusy"  :items="items2"  :fields="fields3"  :current-page="currentPageBom" :perPage="perPageBom" :bordered="true" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"> -->
                            
                            <div slot="table-busy" class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div>
                            <template slot="ID" slot-scope="row">
                              {{row.item.id}}
                            </template>
                            
                            <template slot="file_path" slot-scope="row">
                               <a v-bind:href="row.item.file_path" download><button> <i class="fa fa-download" aria-hidden="true"></i></button> </a>
                              </template>
                          
                          </b-table>
                            
                           
                           
                            <b-pagination
                              v-model="currentPageBom"
                              :total-rows="totalRowsBom"
                              :per-page="perPageBom"
                              class="my-0"
                            ></b-pagination>
                          
                      </div>
                   </div>
            </b-modal>
          </div> 

        <!-- ~~~~~~~~~~~~~~Modal end for BOM Template -->
         <!-- Modal for assigning style to junior buyer -->
          <b-modal id="modal-1" title="Assign style to junior buyer"  v-model="showAssignStyleModal"
              @ok="showAssignStyleModal = false">

              <!-- {{selectedStylesForFileUpload[0].style_name}} -->

            <b-form @submit.prevent="validatesubmitAssignForm(formData)">

              <div class="row">
                <div class="col-11 m-2 ">
                  <label>Style Code</label>
                  <input type="text" class="form-control" v-model="selected_styleName" disabled />
                </div>
                 <div class="col-11 m-2">
                   <label>Select Junior Buyer</label>
                   <b-form-select name="buyername" id="buyername" v-model="buyername"
                        
                      >
                       
                        <option placeholder="Select option"
                            v-for="buyerarr in buyer_list_arr"
                            :value="buyerarr.user_id"
                            :key="buyerarr.user_id"
                            >{{ buyerarr.full_name }}</option
                          >
                      </b-form-select>
                       
                </div>
              </div>

              <div class="mt-5">
                <b-button size="sm"  class="float-right btn btn-danger ml-2 mr-2" @click="cloaseAssignStyleModal" >
                  Cancel
                </b-button> 
                <b-button size="sm" type="submit" class="float-right btn btn-success" >
                  Submit
                </b-button>
              </div>
          
            </b-form>
            
          </b-modal>

         <!-- Art work Image Zoom Model -->
         <b-modal
            id="modal1-lg"
            size="lg"
            title="Image Zoom"
            v-model="openartworkimagemodel"
            @ok="openartworkimagemodel = false"
          >
            <template slot="modal-header">
              <h5>Zoom Image</h5>
              <b-button
                size="sm"
                @click="openartworkimagecancel()"
                style="background: none; border: none;"
                ><i class="fa fa-close"></i
              ></b-button>
            </template>
            <template slot="default" slot-scope="{ hide }">
              <div id="btn_navbar">
                <button type="button" class="btn btn-success" @click="zoomin()">
                  <i class="fa fa-search-plus" aria-hidden="true"
                    >&nbsp;Zoom In</i
                  ></button
                >&nbsp;
                <button type="button" class="btn btn-danger" @click="zoomout()">
                  <i class="fa fa-search-minus" aria-hidden="true"
                    >&nbsp;Zoom Out</i
                  >
                </button>
                <button
                  type="button"
                  class="btn btn-info m-2"
                  @click="showMagnifier()"
                >
                  <i class="fa fa-search" aria-hidden="true"
                    >&nbsp;Magnifier Glass</i
                  >
                </button>
              </div>

              <div class="main1" style="text-align: center;">
                <!-- <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;"/> -->

                <img
                  v-bind:src="style_details.artwork_image"
                  id="map" 
                  style="padding:5px;"
                />
              </div>

              <div slot="footer" class="text-right">
                <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
                <b-button
                  size="sm"
                  variant="danger"
                  @click="openartworkimagecancel()"
                  >cancel</b-button
                >
              </div>
            </template>
            <template slot="modal-footer" slot-scope="{ hide }">
              <b-button size="sm" style="display:none">
                Cancel
              </b-button>
            </template>
          </b-modal>
          <!-- Art work Image Zoom Model -->

          <!-- Grading modal -->
         <b-modal id="showGradeModal" size="md" title="Select grade for the style" v-model="showGradeModal" @ok="showGradeModal = false" v-if="user_type !='Admin'">
            <b-form
            name="addSegmentForm"
             @submit.prevent="validategrade()">

            <b-col sm="12">
                <label for="grade">Select Grade</label>
                <b-form-group>
                <b-form-select required
                    v-model="selected_Grade"
                    id="selected_Grade"
                    name="selected_Grade">
                    <option :value="null">--Select--</option>
                    <option value="A+" >A+</option>
                    <option value="A" >A</option>
                    <option value="B+" >B+</option>
                    <option value="B" >B</option>
                    <option value="C+" >C+</option>
                    <option value="C" >C</option>
                    <option value="D" >D</option>

                </b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="5" style="float:right">
                <b-button type="submit" variant="primary">Submit</b-button> &nbsp;
                <b-button type="button" variant="danger" @click="cancelshowGradeModal()">Cancel</b-button>
            </b-col> 

            </b-form>   
          </b-modal>

        </div> 

  </template>

<style>
.img_class {

  width: 80%;

  height: 250px !important;

  margin-top: 15px;

  text-align: center;

  padding-bottom: 5px;

  /*border-radius: 50em;*/

  /*loadScroll: 500;*/

}

/*v-lazy-image {

opacity: 0;

transition: 15s;

}

 

v-lazy-image.show {

opacity: 1;

}*/

.v-lazy-image {

  opacity: 0;

  transform: scale3d(0.3, 0.3, 0.3);

  transition: opacity 0.5s, transform 0.5s;

}

.v-lazy-image-loaded {

  opacity: 1;

  transform: translate3d(0, 0, 0);

}

/*.v-lazy-image {

opacity: 0;

transform: translate3d(0, 50%, 0);

transition: opacity 2s, transform 0.5s;

}

.v-lazy-image-loaded {

opacity: 1;

transform: translate3d(0, 0, 0);

}*/

.card-body {

  -webkit-box-flex: 1;

  -ms-flex: 1 1 auto;

  flex: 1 1 auto;

  min-height: 1px;

  padding: 1rem;

}

#fileUploadOverlay {
  position: fixed; /* Sit on top of the page content */
  /*display: none;*/ /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .fileUploadLoader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
#designsimage .vue-pdf-embed canvas {
    margin-top: 12px !important;
    width: 220px !important;
    height: 225px !important;
    position: absolute !important;
    left: 18px !important;
}
#alldesignsimage .vue-pdf-embed canvas {
    margin-top: 40px !important;
    width: 220px !important;
    height: 205px !important;
    position: absolute !important;
    left: 18px !important;
}
</style>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import VLazyImage from "v-lazy-image/v2"
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'

const axios = require('axios')


export default {
  name: 'Cards',
  components: {
     VuePdfEmbed,
     VLazyImage
  },
  data: function () {
    return {
      sampelAddModal: false,
     opentablemodel:false,
     openimagemodel:false,
      show: true,
      isCollapsed: true,
      design_list:[],
      sortBy: null,
      POBy: null,
      UtilityBy: null,
      subBy: null,
      currentPage: 1,
      perPage:  20,
      totalRows: 0,

       sortoptions: [
          { value: null, text: 'Please select an option' },
          { value: 'a', text: 'Please select an option' },
          { value: 'b', text: 'Please select an option' },
          { value: 'C', text: 'Please select an option' },
          { value: 'd', text: 'Please select an option' }
        ],
        POoptions: [
          { value: null, text: 'rr' },
          { value: 'a', text: 'dd' },
          { value: 'b', text: 'uu' },
          { value: 'C', text: 'tt' },
          { value: 'd', text: 'ww' }
        ],
     utilityOptions: [
          { value: null, text: 'Please select an option' },
          { value: 'a', text: '1' },
          { value: 'b', text: '2' },
          { value: 'C', text: '3' },
          { value: 'd', text: '4' }
        ],
     subOptions: [
          { value: 'a', text: '22' },
          { value: 'b', text: '169' },
        ],
      collection_title:'',
      po_typearr: [],
       selected_po_id: 0,
       utility_type_arr: [],
       sub_cat_id_arr : [],
       selected_subcat_id: 0,
       sub_cat: 0,
       selected_po_id: 0,
       selected_utility_id: 0,
      selected_collection_id: 0,
      selected_segment_id: 0,

       sub_cat_id_arr: [],
       po_typearr: [],
       selected: '',
       login_user_id: 0,
       search_item: '',
       total_records: [],
       count_arr: [],
       per_page_items: 20,
       search_subcat: 0,
       search_utility: 0,
       search_po: 0,
       total_design_rows: 0,
       // Added Code
       user_type: '',
       brand_title: '',
       customer: {},
       img_path: '',
       showdesigndetails: false,
       style_details: [],
       selected_color_family:'',
       selected_pantone_no:'',
       selected_panton_type:'',
       showhexcolor:'',
       colortype: {},
       customer: {},
       colorcode:{},
       color_name:[],
       color_family:[],
       pantoncolor: [],
       showhexcolor:'',
       pantonno_result:[],
       showcolorname:'',
            SelectPantonType:'',
       sizeset: [],
        invoice_products:[{
              unit: [],
              selectedfromage: [],
              selectedtoage: [],
              quantity: [],
              factorysize: [],
            }
          ],
        selected_month: [],
        selected_age: 0,
        selectedfromage:[],
        selectedtoage: [],
        quantity: [],
        factorysize: [],
        unit_arr: [
          { value: '0', text: 'Month' },
          { value: '1', text: 'Year' }
          ],
         month_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' },
              { value: '17', text: '17' },
              { value: '18', text: '18' },
              { value: '19', text: '19' },
              { value: '20', text: '20' },
              { value: '21', text: '21' },
              { value: '22', text: '22' },
              { value: '23', text: '23' },
              { value: '24', text: '24' }
            ],      
          year_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' }          
              ],
          to_month_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' },
              { value: '17', text: '17' },
              { value: '18', text: '18' },
              { value: '19', text: '19' },
              { value: '20', text: '20' },
              { value: '21', text: '21' },
              { value: '22', text: '22' },
              { value: '23', text: '23' },
              { value: '24', text: '24' }
            ],      
          to_year_arr: [
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' }          
              ],
              route_id:'',
              access_token: '',
              info_length: 0,
              selected_id: '',
              route_status:'',
             selected_brand_id:'',
             selected_brand_type:'',

        // for multiple approve/reject
            selectedDesign:[],
            isAllDesignSelected: false,
            pageNo:1,
            noofpages:'',
            pageOptions: [5, 10, 15],
            sortBy: true,
              
       // Added Code Ends

       // multiple file upload variables
       selectedStylesForFileUpload : [],
       showLoader:false,
       canUploadFiles: false,
       brand_id: '',
       fields3: [
            { key: 'ID', lable: 'ID', class: 'design'},
            { key: 'file_name', label: 'File Name', class: 'design' },
            { key: 'file_path', label: 'Download' ,class: 'design'},
          
          ],
       items2 : [],
       currentPageBom:1,
       perPageBom:10,
      totalRowsBom: 0,
      openartworkimagemodel: false,    
      showAssignStyleModal: false,
      selected_styleName:'',
      selected_styleID:'',
      buyer_list_arr:[],
      buyername:'',
      
      // for show multi color
      selected_mutlicolor:[],
      imgIsLoaded:false,
      // check all
      styleArr :[],
      body1:{},
      checkAll: false,

      // Search Data
      segmentarray_list: [],
      selected_segment_id: null,
      collectionData: [],
      collection_brand_id: "",
      collection_segment_id: "",
      selected_collection_id: null,
      brand_id: '',
      segment_id: '',
      segmentList_arr: [],
      totalRows: 0,
      sub_cat_id_arr: [],
      po_typearr: [],
      sub_catid: null,
      selected_po_id: null,
      result: [],
      designerName:"",
     // For grading system
      showGradeModal: false,
      selected_Grade:null,
      segementid_fields: { text: "text", value: "value" },
      collectionid_fields:  { text: "text", value: "value" },
      subcatid_fields: { text: "text", value: "value" },
      poid_fields:  { text: "text", value: "value" },
      }
  },
    computed: {
        rows() {
          return this.items.length
        },
        
      },
//       mounted() {
//   window.scrollTo(0, 0);
//   window.addEventListener("scroll", this.lazyLoad);
// },
  created: function() {  
    // this.getDesignSampleList();
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData);

  // this.getBrandSegmentList();

  this.access_token=userInfo[0]['token']
  axios.defaults.headers.common['x-access-token'] = this.access_token;
  axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.common['Accept']= 'application/json';
  axios.defaults.headers.common['Origin']='http://localhost:8080';
    
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData);
    this.user_email=userInfo[0].email_id;
    this.user_type= userInfo[0].user_type;
    this.login_user_id = userInfo[0].user_id;
    this.route_id=this.$route.params.id;
    this.brand_id= userInfo[0].user_type=='Admin' ? (userInfo[userInfo.length-1].brand_id ? userInfo[userInfo.length-1].brand_id : null) : userInfo[0].brand_assign
    // if(userInfo[0].user_type=='Admin'){
      this.brand_id= userInfo[0].user_type=='Admin' ? (userInfo[userInfo.length-1].brand_id ? userInfo[userInfo.length-1].brand_id : null) : userInfo[0].brand_assign
    this.showCollection(this.brand_id);
    this.showSubcategory(this.selected_collection_id);
    this.getPoTypeList(this.sub_catid);
    // }
    const myArr = this.route_id.split(",");
     // const mysubcatArr = this.route_id;
     console.log("Myarr",myArr);
     this.route_status=myArr[0];
     console.log("HHHHHH",this.route_status);
     this.selected_brand_id=myArr[1];
     this.selected_brand_type = myArr[2];

     console.log("myArr[1]-------------->",myArr[1])
      if(myArr[1] && myArr[1] != 'undefined'){
      localStorage.setItem('brand_id',myArr[1])
    }
     console.log("TTT",this.selected_brand_id);
    // this.getdesigndetail();
    //this.sub_cat_id_arr=userInfo[0].subcat_assign;
    this.thumbnailsdata(this.pageNo);
    // if(this.user_type=='Admin'){
    // this.getSubCategoryList();
    // }
    
    // this.checkCanUploadFiles()
  },
  mounted() {
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)
    this.getBrandSegmentList();
    let tempLocalStorage = localStorage.filters ? JSON.parse(localStorage.filters) : null
    console.log('tempLocalStorage-------->',tempLocalStorage)
    if(tempLocalStorage){
      if(tempLocalStorage.selected_segment_id){
        this.selected_segment_id = tempLocalStorage.selected_segment_id
        if(this.user_type=='Admin'){
          this.showCollection((userInfo[userInfo.length-1].brand_id ? userInfo[userInfo.length-1].brand_id : null),tempLocalStorage.selected_segment_id)
        }else{
          this.showCollection(userInfo[0].brand_assign,tempLocalStorage.selected_segment_id)
        }
        this.selected_collection_id = tempLocalStorage.selected_collection_id
        if(tempLocalStorage.selected_collection_id){
          this.showSubcategory(tempLocalStorage.selected_collection_id)
        }
        this.sub_catid = tempLocalStorage.sub_catid
        if(tempLocalStorage.sub_catid){
          this.getPoTypeList(tempLocalStorage.sub_catid)
        }
        this.selected_po_id = tempLocalStorage.selected_po_id
      }
      
    }
    this.thumbnailsdata(this.pageNo);
    this.checkCanUploadFiles()
  },

  methods: { 
    imgLoadedMethod: function() {

      // alert("ok")

      this.imgIsLoaded = true;

    },

    // Search function api's

    searchData:function(brand_id){
      console.log("selected_segment_id", this.selected_segment_id)
      this.updateFilters();
      this.thumbnailsdata();
      //this.getdesignheadstyledetails();
    },

        /****** Function to Get Brand & Segments ********/
        getBrandSegmentList:function(){
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        this.brand_assign = userInfo[0].brand_assign;
        if (userInfo[0].user_type == "Brand_Manager") {
          this.selected_brand_manager = userInfo[0].user_id;
        } else {
          this.selected_brand_manager = userInfo[0].brand_manager;
        }
        var obj = {}
        if(userInfo[0].user_type == 'Admin'){
          console.log("userInfo[0].user_type == 'Admin'")
          obj = {brand_id: this.selected_brand_id ? this.selected_brand_id: null}
        }else{
          obj = {
            user_id: this.user_id,
            selected_brand: userInfo[0].brand_assign,
            brand_manager: this.selected_brand_manager,
          }
        }

        axios
          .post(`${CONSTANTS.API_URL+'/'+(userInfo[0].user_type == 'Admin' ? 'getBrandSegmentListForAdminAndVendor' : 'getBrandSegmentList')}`, obj)
          .then((response) => {
           
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // if(userInfo[0].user_type == 'Admin'){
                // this.segmentList_arr = this.result.returnvalue
                // if(this.user_type == 'Admin'){
                    let tempsegement_list =[]
                    if(userInfo[0].user_type == 'Admin'){
                      response.data.returnvalue.map((item, index) => {
                        let tempobj ={}
                        tempobj.text = item.segment_title
                        tempobj.value = item.segment_title
                        tempsegement_list.push(tempobj)

                      })

                    }
                    else{

                      this.result.returnvalue[0]['segment_list'].map((item, index) => {
                      let tempobj ={}
                      tempobj.text = item.segment_title
                      tempobj.value = item.segment_title
                      tempsegement_list.push(tempobj)

                    })

                  }

                    this.segmentarray_list = tempsegement_list;
                // }
                // else{
                //   this.segmentarray_list =this.result.returnvalue
                // }
                this.totalRows = this.result.returnvalue.length
              // }
              // else {
              //   // document.getElementById("overlay").style.display = "none";
              //   this.segmentarray_list = this.result.returnvalue[0]['segment_list'];
              //   this.segmentList_arr = this.result.returnvalue;
              //   this.totalRows = this.segmentList_arr[0]["segment_list"].length;

              //   if (this.totalRows > 0) {
              //     this.segment_id = this.segmentList_arr[0]["segment_list"][0][
              //       "segment_id"
              //     ];
              //     this.brand_id = this.segmentList_arr[0]["segment_list"][0][
              //       "brand_id"
              //     ];
              //     //this.showCollection(this.brand_id, this.segment_id);
              //   }
              // }
            }
            else{
              this.segmentList_arr = [];
              this.totalRows = 0;
            }
          })
           .catch((e) => {
            // this.errors.push(e);
            console.log('getBrandSegmentList error------>',e)
          });

      }
    },

        // Collection list accorfing to segment selected
    showCollection(brand_id, segment_id) {
      this.selected_collection_id=null,
      this.sub_catid=null,
      this.selected_po_id=null,
      this.sub_cat_id_arr = [];
      this.po_typearr = [];

      // document.getElementById("overlay").style.display = "block";
      this.collection_brand_id = brand_id;
      this.collection_segment_id = segment_id;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      var user_id = userInfo[0].user_id;

      const Obj = {
        brand_id: brand_id,
        segment_id: segment_id,
        user_id:  userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getSegmentCollectionList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {

            //if(this.user_type == 'Admin'){
                let tempcollction_list =[]
                  response.data.returnvalue.collections.map((item, index) => {
                    let tempobj ={}
                    tempobj.text = item.collection_title
                    tempobj.value = item.collection_title
                    tempcollction_list.push(tempobj)

                  })
                this.collectionData = tempcollction_list
            //  }
            //  else{
            //    this.collectionData = response.data.returnvalue.collections;
            //  }
             console.log("collections");
             console.log(this.collectionData)
          }else{
            this.collectionData = []
          }
        })
         .catch((e) => {
            this.errors.push(e);
          });
    
    },

        /******Function To Get Sub Category List********/

      // Sub Category list accorfing to segment selected
        showSubcategory(collection_id) {
         // this.updateFilters(); 
          this.sub_catid = null,
          this.selected_po_id = null,
          this.po_typearr = [];

          // document.getElementById("overlay").style.display = "block";
          var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)

          const Obj = {
            collection_id,
            user_id:  userInfo[0].user_id,
          };
          axios
            .post(`${CONSTANTS.API_URL}/getSubcategoryForDashboardFilter`, Obj)
            .then((response) => {
              // document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                // if(this.user_type == 'Admin'){
                    let tempsubcat_list =[]
                    response.data.returnvalue.map((item, index) => {
                      let tempobj ={}
                      tempobj.text = item.sub_cattitle
                      tempobj.value = item.sub_catid
                      tempsubcat_list.push(tempobj)

                    })
                  this.sub_cat_id_arr = tempsubcat_list
                // }
                // else{
                //   this.sub_cat_id_arr = response.data.returnvalue;
                // }
              }else{
                this.sub_cat_id_arr = []
              }
            })
            .catch((e) => {
                this.errors.push(e);
              });
                
        },

        /******Function To Get PO Type List********/
    getPoTypeList: function(subcat_id) {
      this.selected_po_id=null;

      // document.getElementById("overlay").style.display = "block";

       var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData)

      // this.isBusy = true;
      const Obj = {
        subcat_id,
        user_id:  userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getPoTypeList`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            // if(this.user_type == 'Admin'){
              let temppo_list =[]
                response.data.returnvalue.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.title
                  tempobj.value = item.po_id
                  temppo_list.push(tempobj)

                })
              this.po_typearr = temppo_list
            // }
            // else{
            //   this.po_typearr = this.result.returnvalue;
            // }
            // this.totalRows = this.result.returnvalue.length;
            // this.isBusy = !this.isBusy;
          } else {
            this.po_typearr = [];
            // this.totalRows=0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    updateFilters(){
        
        const filters = {
          "selected_segment_id" : this.selected_segment_id,
          "selected_collection_id" : this.selected_collection_id,
          "sub_catid": this.sub_catid,
          "selected_po_id": this.selected_po_id
        };
        localStorage.setItem('filters',JSON.stringify(filters));
        console.log(filters);
        console.log(this.selected_po_id);
      },

    refresh: function () {
      this.collectionData = [];
      this.sub_cat_id_arr = [];
      this.po_typearr = [];
      this.selected_subcat_id = null,
      this.selected_segment_id = null,
        this.selected_collection_id = null,
        this.sub_catid = null,
        this.selected_po_id = null,
        localStorage.removeItem('filters');
        this.thumbnailsdata();
        this.showCollection(this.brand_id)
        this.showSubcategory(this.selected_collection_id)
        this.getPoTypeList(this.sub_catid)
        //this.getdesignheadstyledetails();

    },
   
    //   refresh: function(){
    //   this.selected_subcat_id= '';
    //   this.selected_utility_id= '';
    //   this.selected_po_id= '';
    //   this.search_item='';
    //   this.search_po=0;
    //   this.search_utility=0;
    //   this.search_subcat=0;
    //   // this.search_item=0;
    //   this.thumbnailsdata(this.pageNo);
 

    // },
      /******Function To Get Sub Category List********/
    //   getSubCategoryList: function(value) {    
       
    //   axios.post(`${CONSTANTS.API_URL}/getSubCategoryList`,{})
    //   .then(response => {
    //     //document.getElementById("overlay").style.display = "none";
    //     this.result = response.data

    //     if (this.result.returnmsg === 'Successful') {
    //       this.sub_cat_id_arr  = this.result.returnvalue;
    //       this.totalRows = this.result.returnvalue.length;
          
          
    //     }else {
    //      this.sub_cat_arr =[];
    //      this.totalRows=0;
    //     }


    //   })
    //   .catch(e => {
    //     this.errors.push(e)
    //   })
    // },

    openArtWorkimage: function() {
      this.openartworkimagemodel = !this.openartworkimagemodel;
    },

    openartworkimagecancel: function() {
      this.openartworkimagemodel = !this.openartworkimagemodel;
    },


    //Code For Search Filter
    subcatsearch: function(value){
    this.search_subcat=0;
    this.search_subcat= value;
    this.thumbnailsdata(this.pageNo);
   },
   utilitysearch: function(value){
    this.search_utility= 0;
    this.search_utility=value;
    this.thumbnailsdata(this.pageNo);
   },
   posearch: function(value){
    this.search_po=0;
    this.search_po=value;
    this.thumbnailsdata(this.pageNo);
   },
   clickCallback (pageNo)
       {
        // alert(" i m in pagination task");
      // alert(pageNo)
      this.thumbnailsdata(pageNo);
    },
    //Code For search Filter Ends

    redirect: function(){
      this.$router.go(-1)
    },

    //Code For Pagination
    paginationfunction: function(){
      // alert("ok")
      var header = document.getElementById("myDIV");
      var btns = header.getElementsByClassName("btn");
      for (var i = 0; i < btns.length; i++) {
        btns[i].addEventListener("click", function() {
        var current = document.getElementsByClassName("active");
        current[0].className = current[0].className.replace(" active", "");
        this.className += " active";
        });
      }
    },
    //Code For Pagination Ends

                // Function For Action on status
    updatestylestatus: function(comment,value) {
    
       console.log("this.selected_Grade------------->", this.selected_Grade)

      if((this.selected_Grade == '' || this.selected_Grade == null) && this.user_type !='Admin' && this.status != 'rejected' && this.status != 'Feedback' )
      {
           this.$fire({
                text: "Please select grade for the style",
                type: "warning",
                timer: 30000,
              });
      }
      else{

        document.getElementById("overlay").style.display = "block";
        var status = value;
        var comment = comment;
            var userData = localStorage.getItem('userData');
            var userInfo = JSON.parse(userData)
            var user_id = userInfo[0].user_id; 
        if(status!=''){          
        const Obj={
            operational_status: status,
            updated_by: userInfo[0].email_id,
            user_id: userInfo[0].user_id,
            style_id: this.selected_style_id,
            comments : comment,
            grade: this.selected_Grade
        } 
        axios.post(`${CONSTANTS.API_URL}/updatestylestatus`,Obj)
        .then(response => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data
            if (this.result.returnmsg === 'Successful') {
            // alert("Status Updated Successfully");
                this.$fire({
                    text:"Status Updated Successfully",
                    type: "success",
                    timer: 30000
                            })
            this.showdesigndetails = !this.showdesigndetails;
            this.thumbnailsdata(this.pageNo); 
            }else {
            // alert("Please Check Status");
            this.$fire({
                    text:"Please Check Status",
                    type: "warning",
                    timer: 30000
                            })
            
            }


        })
        .catch(e => {
            this.errors.push(e)
        })
        }
        else{
        document.getElementById("overlay").style.display = "none";
        this.$fire({
                    text:"Please Check Status",
                    type: "warning",
                    timer: 120000
            })
        }

      }
    },


    commentcancel: function(){
      
      this.showdesigndetails = !this.showdesigndetails;
      // this.isBusy = !this.isBusy;
    },

               /****** Function to design details ********/
       getdesigndetail: function () {
         document.getElementById("overlay").style.display = "block";
           this.img_path='';
           // this.isBusy = true;
       
           const Obj = {
                style_id: this.selected_style_id 
                             
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
              
            this.style_details  = this.result.returnvalue[0];
            this.img_path = this.style_details.style_image;
            this.totalRows = this.result.returnvalue.length;
            this.selected_color_family= this.style_details.color_family;
            this.selected_pantone_no= this.style_details.pantone_no;
            this.selected_panton_type= this.style_details.panton_type;
            this.getselectedfamilycolor(this.selected_panton_type);
            this.setSelectedcolor(this.style_details.pantone_no,0);
            // this.isBusy = !this.isBusy;   
            this.selected_mutlicolor = this.style_details.color.split(",")
             this.sizeset = this.style_details.no_of_sizeset;
             var temp_selected_unit= this.style_details.size_details[0].unit[0];

            var temp_selected_fromage= this.style_details.size_details[0].selectedfromage[0];
            
            var temp_selected_toage=this.style_details.size_details[0].selectedtoage[0];
            // if(this.style_details.size_details[0].quantity.length!=0){
            //     var temp_qty=this.style_details.size_details[0].quantity[0];
            //   }
            //   else{
            //     var temp_qty=[];
            //   }
            //   if(this.style_details.size_details[0].factorysize.length!=0){
            //     var temp_factorysize= this.style_details.size_details[0].factorysize[0];
            //   }
            //   else{
            //     var temp_factorysize=[];
            //   }
               console.log("^^^^^^^^^^^^^^^^^^^^^^^^",temp_selected_unit)
               // var temp_qty=this.quotationlist.size_details[0].quantity[0];
               // console.log("))))))))))))))))))))",this.quotationlist.size_details[0].quantity[0].length);
               for( var i =0 ; i<this.style_details.size_details[0].selectedfromage[0].length;i++){
                this.selected_month[i]=temp_selected_unit[i];
                this.selectedfromage[i]=temp_selected_fromage[i];
                this.selectedtoage[i]= temp_selected_toage[i];
                // if(this.style_details.size_details[0].quantity.length!=0){
                //   this.quantity[i]= temp_qty[i];
                // }
                // if(this.style_details.size_details[0].factorysize.length!=0){
                //   this.factorysize[i]= temp_factorysize[i];
                // }
               }                          
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },

       //Panton Color
    getcolorfamilylist: function(value) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     
      const Obj ={"color_type":"TCX"}
      axios.post(`${CONSTANTS.API_URL}/getcolorfamilylist`,Obj)
        .then((result) => {
          if (result.data.returnmsg === 'Successful') {
            this.color_family  = result.data.returnvalue;
          }else {
           this.color_family =[];
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      
    },

        getselectedfamilycolor: function(color) {
          const Obj = {
      color_family: color
      }
      this.temp_selected_panton_type='';
      this.temp_selected_panton_type=color;
      console.log("temp_selected_panton_type",this.temp_selected_panton_type);
      axios.post(`${CONSTANTS.API_URL}/getlistagainstcolorfamily`, Obj)
        .then((result) => {
          this.result1 = result.data
          if (this.result1.returnmsg === 'Successful') {
            this.color_name  = this.result1.returnvalue;
            var data = [];
 
              this.color_name.forEach(function (srData) {
                data.push({
                  key:srData.pantone_no,
                  label:srData.color_name+ ' - '+srData.pantone_no
                });
              });
              console.log("OOOOOOOOOOOOOOOOOOOOOO",data)
              this.color_name = data;
          }else {
           this.color_name =[];
          }

          
        }) 
    },
    setSelectedcolor: function(value, checked_val) 

    {
      // alert("innn");
      console.log("Vallllll",value);
      console.log("checked_val",checked_val);
      // var x=document.getElementById('opt').style.backgroundColor=opt.value;
      // .style.backgroundColor=colorData;
      // document.body.style.backgroundColor =  colorData;
      
      // var colorData='12-6204 TCX'

      if(checked_val==0){
      var Obj = {
      pantone_no: value
      }
      }
      else{
        var Obj = {
      pantone_no: value.key
      }
      }
console.log("OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO",Obj)
      axios.post(`${CONSTANTS.API_URL}/getlistagainstpantonno`, Obj)
        .then((result) => {
          this.pantonno_result = result.data
          if (this.pantonno_result.returnmsg === 'Successful') {
            if(this.selected_panton_type != 'OTHERS'){
            this.pantoncolor  = this.pantonno_result.returnvalue
            this.showhexcolor=this.pantoncolor[0].hex_code;
            var temp_hex=this.pantoncolor[0].hex_code;
            this.showcolorname=this.pantoncolor[0].color_name;
            console.log("CCCCCCCCCCCCCCCCCCCCCCCCCC",this.showcolorname);
            var temp_colorname=this.pantoncolor[0].color_name;
            this.selected_final_color= this.showcolorname+ " "+this.showhexcolor
            if(checked_val==0){
              this.temp_selected_pantone_no=value;
            }
            else{
              this.temp_selected_pantone_no=value.key;
            }
            
               document.getElementById("showcolor").style.backgroundColor =this.showhexcolor;
             document.getElementById("showcolor").innerHTML=this.showcolorname+ " - " +this.showhexcolor;
            document.getElementById("showcolor1").style.backgroundColor =temp_hex;
             document.getElementById("showcolor1").innerHTML=temp_colorname+ " - " +this.showhexcolor;
            // }
           }

          }else {
           this.pantoncolor =[];
          }    
        })   
    },

  /******Function To Get PO Type List Ends********/

   zoomin: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth >= 680) return false;
         else{
            myImg.style.width = (currWidth + 100) + "px";
        } 
    },
    zoomout: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth <= 270) return false;
     else{
            myImg.style.width = (currWidth - 100) + "px";
        }
    },
        openimagecancel: function(){
      this.openimagemodel = !this.openimagemodel;
     },
     

    changesubcat(id){
    this.sub_cat= id;
    this.getUtilityTypeList();
    this.getPoTypeList();
   },

   opendesignModal(style_id,brand_title,segment_title,collection_title,style_name) {
        this.comment= '';
        this.status= '';
        this.selected_style_id = style_id;
        this.customer.brand_title = brand_title;
        this.customer.segment_title = segment_title;
        this.customer.collection_title = collection_title;
        this.customer.style_name = style_name;
        this.getdesigndetail();
        this.showdesigndetails =true;
        
 },

     /******Function To Get Utility Type List********/
      getUtilityTypeList: function() {
        // document.getElementById("overlay").style.display = "block";
        
      this.isBusy = true;  
      const Obj={
        subcat_id: this.sub_cat
      }   
      axios.post(`${CONSTANTS.API_URL}/getUtilityTypeList`,Obj)
      .then(response => {
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          // document.getElementById("overlay").style.display = "none";
          this.utility_type_arr  = this.result.returnvalue;
          console.log("this.utility_type_arr",this.utility_type_arr);
          this.totalRows = this.result.returnvalue.length;
          this.isBusy = !this.isBusy;
          
        }else {
         this.utility_type_arr =[];
         this.totalRows=0;
           this.isBusy = !this.isBusy;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

  /******Function To Get Utility Type List Ends********/


  /******Function To Get PO Type List********/
    //   getPoTypeList: function() {
    //     // document.getElementById("overlay").style.display = "block";
       
    //   this.isBusy = true;     
    //    const Obj={
    //     subcat_id: this.sub_cat
    //    }
    //   axios.post(`${CONSTANTS.API_URL}/getPoTypeList`,Obj)
    //   .then(response => {
    //     // document.getElementById("overlay").style.display = "none";
    //     this.result = response.data

    //     if (this.result.returnmsg === 'Successful') {
    //       this.po_typearr  = this.result.returnvalue;
    //       console.log("this.utility_type_arr",this.po_typearr);
    //       // this.selected_po_id=this.po_typearr[0].po_id;
    //       this.totalRows = this.result.returnvalue.length;
    //       this.isBusy = !this.isBusy;
          
    //     }else {
    //      this.po_typearr =[];
    //      this.totalRows=0;
    //        this.isBusy = !this.isBusy;
    //     }


    //   })
    //   .catch(e => {
    //     this.errors.push(e)
    //   })
    // },
     //Table Set Function
       opentable:function(){
           this.opentablemodel=!this.opentablemodel;
       },
       opentablecancel:function(){
           this.opentablemodel=!this.opentablemodel;
       },
     
     

  /******Function To Get PO Type List Ends********/    

    thumbnailsdata1: function(){
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem('userData');
  var userInfo = userData ? JSON.parse(userData) : null;
  this.access_token=userInfo && userInfo[0]['token'] ? userInfo[0]['token'] : null;
  axios.defaults.headers.common['x-access-token'] = this.access_token;
  axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
  axios.defaults.headers.common['Accept']= 'application/json';
  axios.defaults.headers.common['Origin']='http://localhost:8080';
      // var userData = localStorage.getItem('userData');
      // var userInfo = JSON.parse(userData);
          const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               // keyword: this.$route.params.id,
               keyword: this.route_status,
               brand_id: userInfo[0].brand_assign, 
               po_id: this.search_po,
               utility_id: this.search_utility,
               sub_catid: this.search_subcat,
               search_value: this.search_item
           
          }
            axios.post(`${CONSTANTS.API_URL}/getdashboardlistingforbrandmangerandbuyer`,Obj)
            .then(response => {
              document.getElementById("overlay").style.display = "none";
                if(response.data.returnmsg == 'Successful') {
                  this.design_list  = response.data.returnvalue;
                  console.log("WWWWWWWWWWWWWWWWWWWWWWWWWWWWWW",this.design_list);
                  this.total_design_rows = response.data.returnvalue.length;
                  this.total_records.push(response.data.returnvalue.length);
                  var temp=[];
                  for(var i=0;i<=this.total_records;i++){
                    this.count_arr.push(i); 
                  }
                  
                    // alert("New Collection Added Successfully.");
                    // window.location.href ="collections";
                } else {
                  if (response.data.returnmsg === 'Unsuccessful') {
                    document.getElementById("overlay").style.display = "none";
                    this.total_design_rows = 0;
                    this.design_list=[];
                    
                  }
                }
              })
    },
     styledropdown:function(){
      var typelisting = document.getElementById("typelist");
  if (typelisting.style.display === "block") {
    typelist.style.display = "none";
  } else {
    typelisting.style.display = "block";
  }
   
      // document.getElementById('typelist').style.display="none";
    
    },

    thumbnailsdata: function(page) 
    {
      var storedFilters = localStorage.getItem('filters') ? JSON.parse(localStorage.getItem('filters')) : null;
      console.log("Filters      ",storedFilters);
            
      if(storedFilters){
        this.selected_po_id = storedFilters.selected_po_id ? storedFilters.selected_po_id : 0;
        this.selected_subcat_id = storedFilters.sub_catid ? storedFilters.sub_catid : null;
        this.selected_collection_id = storedFilters.selected_collection_id ? storedFilters.selected_collection_id : 0;
        this.selected_segment_id = storedFilters.selected_segment_id ? storedFilters.selected_segment_id : 0;
      }
      
      // alert(page)
      var userData = localStorage.getItem('userData');
          var userInfo = userData ? JSON.parse(userData) : null
        this.access_token=userInfo[0]['token']
        axios.defaults.headers.common['x-access-token'] = this.access_token;
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
        axios.defaults.headers.common['Accept']= 'application/json';
        axios.defaults.headers.common['Origin']='http://localhost:8080';
      // document.getElementById("overlay").style.display = "block";
      this.isBusy = !this.isBusy;
      // var userdata = localStorage.getItem("userData");
      // var userInfo = JSON.parse(userdata);
      this.login_user_id = userInfo[0].user_id;
      if(userInfo[0].user_type=='Admin'){
        this.info_length= 0;
      this.info_length=userInfo.length;
      for(var i=1;i<=userInfo.length-1;i++){
        this.selected_id=userInfo[i].brand_id;
      }
        const Obj={
            user_type: userInfo[0].user_type,
            keyword: this.route_status,
            po_id: this.selected_po_id,
            utility_id: this.selected_utility_id,
            sub_catid: this.selected_subcat_id,
            collection_id: this.selected_collection_id,
            segment_id: this.selected_segment_id,
            search_value: this.search_item,
            limit:'20',
            downloadalldata : 'no',
            page_no:page,
            // brand_id: this.selected_id
             brand_id:this.selected_brand_id == 'undefined' ? this.selected_id : this.selected_brand_id,
             brand_type:this.selected_brand_type
          }



        axios.post(`${CONSTANTS.API_URL}/getfashionheadstyledetails`,Obj).then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          console.log("Result", this.result);

          if (this.result.returnmsg === 'Successful') {
            
            this.design_list = response.data.returnvalue;
            this.designerName = this.result.returnvalue[0].designer_name;
             console.log("Design_Listttttttttttttttttttt", this.design_list);
              this.total_design_rows = this.result.totalrecords;
                  
            console.log("HHHHHH",this.total_design_rows);
            this.noofpages=parseInt(this.total_design_rows)/20;
           
           this.noofpages=Math.ceil( this.noofpages);
                  this.total_records.push(response.data.returnvalue.length);
                  var temp=[];
                  for(var i=0;i<=this.total_records;i++){
                    this.count_arr.push(i); 
                  }
            
          }else {
            document.getElementById("overlay").style.display = "none";
                    this.total_design_rows = 0;
                    this.design_list=[];
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else if(userInfo[0].user_type=='Brand_Manager' || userInfo[0].user_type=='Buyer' || userInfo[0].user_type == "Buying_Head"){
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               keyword: this.route_status,
               brand_id: userInfo[0].brand_assign,
               po_id: this.selected_po_id,
               utility_id: this.selected_utility_id,
               sub_catid: this.selected_subcat_id,
               collection_id: this.selected_collection_id,
               segment_id: this.selected_segment_id,
               limit:'20',
               page_no:page,
               search_value: this.search_item  
            }
            
     
        axios.post(`${CONSTANTS.API_URL}/getdashboardlistingforbrandmangerandbuyer`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
             this.design_list  = response.data.returnvalue;
            this.total_design_rows = this.result.totalrecords;
                  
            console.log("HHHHHH",this.total_design_rows);
            this.noofpages=parseInt(this.total_design_rows)/20;
           
           this.noofpages=Math.ceil( this.noofpages);
                  this.total_records.push(response.data.returnvalue.length);
                  var temp=[];
                  for(var i=0;i<=this.total_records;i++){
                    this.count_arr.push(i); 
                  }
            
          }else {
            document.getElementById("overlay").style.display = "none";
                    this.total_design_rows = 0;
                    this.design_list=[];
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else if(userInfo[0].user_type=='Brand_Designer'){
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               keyword: this.route_status,
               brand_id: userInfo[0].brand_assign,
               po_id: this.selected_po_id,
               utility_id: this.selected_utility_id,
               sub_catid: this.selected_subcat_id,
                collection_id: this.selected_collection_id,
                segment_id: this.selected_segment_id,
                limit:'20',
                page_no:page,
               search_value: this.search_item
            }
     
        axios.post(`${CONSTANTS.API_URL}/getdesignerstyledetails`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
             this.design_list  = response.data.returnvalue;
            this.total_design_rows = this.result.totalrecords;
                  
            console.log("HHHHHH",this.total_design_rows);
            this.noofpages=parseInt(this.total_design_rows)/20;
           
           this.noofpages=Math.ceil( this.noofpages);
                  this.total_records.push(response.data.returnvalue.length);
                  var temp=[];
                  for(var i=0;i<=this.total_records;i++){
                    this.count_arr.push(i); 
                  }
            
          }else {
            document.getElementById("overlay").style.display = "none";
                    this.total_design_rows = 0;
                    this.design_list=[];
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else if(userInfo[0].user_type=='Fit_Technician'){
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               keyword: this.route_status,
               brand_id: userInfo[0].brand_assign,
               po_id: this.selected_po_id,
               utility_id: this.selected_utility_id,
               sub_catid: this.selected_subcat_id,
               collection_id: this.selected_collection_id,
               segment_id: this.selected_segment_id,
               search_value: this.search_item,
               limit:'20',
               page_no:page,
            }
     
        axios.post(`${CONSTANTS.API_URL}/getdashboardlistingforfit_tech`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.design_list  = response.data.returnvalue;
            this.total_design_rows = this.result.totalrecords;
                  
            console.log("HHHHHH",this.total_design_rows);
            this.noofpages=parseInt(this.total_design_rows)/20;
           
           this.noofpages=Math.ceil( this.noofpages);
                  // this.total_design_rows = response.data.returnvalue.length;
                  this.total_records.push(response.data.returnvalue.length);
                  var temp=[];
                  for(var i=0;i<=this.total_records;i++){
                    this.count_arr.push(i); 
                  }
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else if(userInfo[0].user_type=='Quality_Controller'){
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               // keyword: this.$route.params.id,
               keyword: this.route_status,
               brand_id: userInfo[0].brand_assign,
               po_id: this.search_po,
               utility_id: this.search_utility,
               sub_catid: this.search_subcat,
               search_value: this.search_item
              // user_id : 25
            }
    
        axios.post(`${CONSTANTS.API_URL}/getdashboardlistingforqualitycontrol`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.design_list  = response.data.returnvalue;
                  this.total_design_rows = response.data.returnvalue.length;
                  this.total_records.push(response.data.returnvalue.length);
                  var temp=[];
                  for(var i=0;i<=this.total_records;i++){
                    this.count_arr.push(i); 
                  }
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else if(userInfo[0].user_type=='Quality_Executive'){
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               // keyword: this.$route.params.id,
               keyword: this.route_status,
               brand_id: userInfo[0].brand_assign,
               po_id: this.search_po,
               utility_id: this.search_utility,
               sub_catid: this.search_subcat,
               search_value: this.search_item
              // user_id : 25
            }
    
        axios.post(`${CONSTANTS.API_URL}/getdashboardlistingforQC_Executive`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.design_list  = response.data.returnvalue;
                  this.total_design_rows = response.data.returnvalue.length;
                  this.total_records.push(response.data.returnvalue.length);
                  var temp=[];
                  for(var i=0;i<=this.total_records;i++){
                    this.count_arr.push(i); 
                  }
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      else{
        // var userData = localStorage.getItem('userData');
        // var userInfo = JSON.parse(userData)
      const Obj = {
               user_id : this.login_user_id,
               user_type : userInfo[0].user_type,
               keyword: this.route_status,
               brand_id: userInfo[0].brand_assign,
               brand_manager: userInfo[0].brand_manager,
               po_id: this.selected_po_id,
               utility_id: this.selected_utility_id,
               sub_catid: this.selected_subcat_id,
               collection_id: this.selected_collection_id,
               segment_id: this.selected_segment_id,
               limit:'20',
               page_no:page,
               search_value: this.search_item
            }
     
        axios.post(userInfo[0].user_type=='Junior_Buyer'? `${CONSTANTS.API_URL}/getDashboardListingforJuniorBuyer`:`${CONSTANTS.API_URL}/getdesignheadstyledetails`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
             this.design_list  = response.data.returnvalue;
                  // this.total_design_rows = response.data.returnvalue.length;
              this.total_design_rows = this.result.totalrecords;
                  
            console.log("HHHHHH",this.total_design_rows);
            this.noofpages=parseInt(this.total_design_rows)/20;
           
           this.noofpages=Math.ceil( this.noofpages);    
          this.total_records.push(response.data.returnvalue.length);
                  var temp=[];
                  for(var i=0;i<=this.total_records;i++){
                    this.count_arr.push(i); 
                  }
            
          }else {
            document.getElementById("overlay").style.display = "none";
                    this.total_design_rows = 0;
                    this.design_list=[];
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      }
    },

  // logic start for multiple approve/reject
    setSelectedDesign : function(checked,value){
      //console.log(checked +"=>"+value)
      if(checked && !this.selectedDesign.includes(value)){
        this.selectedDesign.push(value) 
      }else{
        let tempList = this.selectedDesign.filter((item)=>item!==value)
        this.selectedDesign = tempList
      }
      //console.log("Selected For Approve list=> "+this.selectedDesign)
    },

    isDesignSelected : function(value){
      this.checkAll = false;
      // alert(this.isAllDesignSelected)
      //  this.isAllDesignSelected == false;
      return this.selectedDesign.includes(value)
     
    },

    allDesignSeleted: function(checked){
      // alert(this.checkAll)
      this.isAllDesignSelected = checked
      this.selectedDesign = [];
      if(this.isAllDesignSelected){
        for(let item of this.design_list){
          
          if(!this.selectedDesign.includes(item.style_id)){
          this.selectedDesign.push(item.style_id)
          }
        }
      }else{
        this.selectedDesign = []
      }
      this.getStyleIdList();
    },

     getStyleIdList(){
      document.getElementById("overlay").style.display = "block";
      
        if(this.isAllDesignSelected == true){

        var userData = localStorage.getItem("userData");
        var userInfo = JSON.parse(userData);
        // console.log("tempbrandobje", userInfo[1].brand_id)

         var tempbrandobje = []

        if(this.user_type == 'Admin')
        { 
          var localbrandid = localStorage.getItem('brand_id');
          tempbrandobje.push(localbrandid)

        }else{
          tempbrandobje.push(userInfo[0].brand_assign)
  
        }

        this.Object1 ={ 
            user_id: this.login_user_id,
            user_type: userInfo[0].user_type,
            brand_manager: userInfo[0].brand_manager,
            keyword: this.route_status,
            brand_id: tempbrandobje,
            po_id: this.search_po,
            utility_id: this.search_utility,
            sub_catid: this.search_subcat,
            search_value: this.search_item,
             downloadalldata : 'no',
              }
        
        }
        
         axios
          .post(`${CONSTANTS.API_URL}/getStyleIdList`, this.Object1)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;

            if (this.result.returnmsg === "Successful") {
                this.styleArr = this.result.returnvalue;
              
            }else{
               this.$fire({
                text: "Something went wrong, Please try again!",
                type: "error",
                timer: 30000,
              });
             
            }
          })
      

    },



  //     lazyLoad: function () {
  //   let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  //   let active = false;
  //   if (active === false) {
  //     active = true;
  //     setTimeout(() => {
  //       lazyImages.forEach(function (lazyImage) {
  //         if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
  //           lazyImage.src = lazyImage.dataset.src;
  //           lazyImage.classList.remove("lazy");
  //           // console.log("lazyImages",lazyImages.length);
  //           lazyImages = lazyImages.filter(function (image) {
  //             return image !== lazyImage;
  //           });

  //           if (lazyImages.length === 0) {

  //             window.removeEventListener("scroll", this.lazyLoad);
  //           }
  //         }
  //       });
  //       active = false;
  //     }, 200)

  //   }
  // },

    approveDesign: function(action){
      document.getElementById("overlay").style.display = "block";
      //console.log(this.selectedDesign)
      let url = CONSTANTS.API_URL+'/updateStyleStatusBulk'
      if(this.isAllDesignSelected == true)
      {
         this.body1 = {
            operational_status: action,
            style_id: this.styleArr,
            user_id: this.login_user_id,
            updated_by: this.user_email,
            user_type: this.user_type,
            isCheckAll: "True",
          }
      }else{
          this.body1 = {
            operational_status: action,
            style_id: this.selectedDesign,
            user_id: this.login_user_id,
            updated_by: this.user_email,
            user_type: this.user_type,
            isCheckAll: "",
          };
      }
      //console.log(body)

      axios.defaults.headers.common['x-access-token'] = this.access_token;
      axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
      axios.defaults.headers.common['Accept']= 'application/json';
      //axios.defaults.headers.common['Origin']='http://localhost:8080';

      axios.post(url,this.body1)
      .then(res=>{
        console.log(res)
        document.getElementById("overlay").style.display = "none";
        this.result = res.data

        if(this.result.returnmsg === 'Successful') {
              if ((localStorage.getItem('selectedBrandId') == '' || 
                      localStorage.getItem('selectedBrandId') == null || 
                      localStorage.getItem('selectedBrandId') == undefined
                    ) || (
                      this.result.returnvalue[0].style_code == null ||
                      this.result.returnvalue[0].style_code == '' || 
                      this.result.returnvalue[0].style_code == undefined
                    )

                    )
                    
                    {

                      this.$fire({
                            text: "Status Updated Successfully",
                            type: "success",
                            timer: 30000,
                      });
                      this.selectedDesign=[];
                      this.selectedDesign.length=0;
                      this.isAllDesignSelected = false;
                      this.thumbnailsdata();
                      this.checkAll = false;
                      document.getElementById('checkAll').checked = false
                      
            }
           
            else {
            var userData = localStorage.getItem("userData");
            var userInfo = JSON.parse(userData);
            let brandName = JSON.parse(localStorage.getItem('selectedBrandId')).target.value.split('+');
                const emailObj = {
                  style_code: this.result.returnvalue[0].style_code,
                  brand_name: brandName,
                  designer_name: this.designerName,
                  user_id: userInfo[0].user_id,
                }

              console.log("emailobj--------------------------->", emailObj);
              
              axios
                .post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj)
                .then((response) => {
                  document.getElementById("overlay").style.display = "none";
                  if (response.data.returnmsg === "Successful") {
                    this.$fire({
                      text: "Status Updated Successfully and email has been sent for approval",
                      type: "success",
                      timer: 30000
                    })

                  }
                  else {
                    this.$fire({
                      text: response.data.returnvalue,
                      type: "danger",
                      timer: 30000,
                    });
                  }

                }) 
                
          this.selectedDesign=[];
          this.selectedDesign.length=0;
          this.isAllDesignSelected = false;
          this.thumbnailsdata();
          this.checkAll = false;
          document.getElementById('checkAll').checked = false
        }

      }
      else{
          this.$fire({
            text:"Please Check Status",
            type: "warning",
            timer: 30000
          })
          this.isAllDesignSelected = false;
           this.checkAll = false;
            document.getElementById('checkAll').checked = false
        }
      })
      .catch(err=>{
        console.log(err)
        document.getElementById("overlay").style.display = "none";
        this.errors.push(err)
        this.$fire({
                text:"Error while updating status!",
                type: "warning",
                timer: 30000
                      })
        })
    },
 // logic end for multiple approve/reject

    handleFileUploadSelect : function(style_id,style_name,isChecked){
      //alert(style_id+"=>"+isChecked)
      let tempArr = [...this.selectedStylesForFileUpload]
      if(isChecked){
        tempArr.push({"style_id":style_id,"style_name":style_name})
      }else{
        tempArr = tempArr.filter((item)=>item.style_id!==style_id)
      }
      this.selectedStylesForFileUpload = tempArr
      console.log(tempArr)
    },

    handleUploadFileBtnClick: function(){
       console.log(this.selectedStylesForFileUpload)
      this.$bvModal.show("fileUploadModal")
    },

     // assign style to junior buyer
    assignStyle(value){
      console.log(value)
      this.selected_styleName = value.style_code;
      this.selected_styleID = value.style_id;
      console.log("dDDDDDDDDDD",this.selected_styleName)
      this.showAssignStyleModal =! this.showAssignStyleModal,
      this.getBuyerList();
    },

    getBuyerList(){
       var userData = localStorage.getItem("userData");
       var userInfo = JSON.parse(userData);

      document.getElementById("overlay").style.display = "block";
      const obj={

        user_id: userInfo[0].user_id,
        user_type: userInfo[0].user_type ,
        brand_id: userInfo[0].brand_assign,
      }

      axios.post(`${CONSTANTS.API_URL}/getBuyerList`, obj)
      .then((response) => {
        document.getElementById("overlay").style.display = "none";
         if (response.data.returnmsg === "Successful") {
          console.log(response.data.returnvalue)
          this.buyer_list_arr = response.data.returnvalue;
         }
      })      


    },

        validatesubmitAssignForm(scope){
      var userData = localStorage.getItem("userData");
       var userInfo = JSON.parse(userData);
      document.getElementById("overlay").style.display = "block";
       this.$validator.validateAll(scope).then((result) => {
        if (result) {
          const obj={
            style_id: this.selected_styleID ,
            buyer_id: this.buyername,
            updated_by: userInfo[0].email_id
          }
          console.log(obj)

          axios.post(`${CONSTANTS.API_URL}/assignStyleToJuniorBuyer`, obj)
          .then((response)=>{
            document.getElementById("overlay").style.display = "none";
            if(response.data.returnmsg === 'Successful'){
               this.$fire({
                text: "Style assigned successfully",
                type: "success",
                timer: 30000,
              });
              this.buyername = ''
               this.showAssignStyleModal = false;
               this.thumbnailsdata(1);
               this.clickCallback(1);

            }else{
               this.$fire({
                text: response.data.returnvalue,
                type: "error",
                timer: 30000,
              });
              this.buyername = ''
               this.showAssignStyleModal = false;
               this.thumbnailsdata(1);
            }
          })
        }
      });

    },

    cloaseAssignStyleModal(){
      this.buyername = '',
      this.showAssignStyleModal = false;
    },

    handleFileUpload: function(file,style_id,category_name){
      if(file!==undefined){
        if(file.type.includes("image") || file.type.includes("application")){
      document.getElementById("fileUploadOverlay").style.display = "block"

      let body = new FormData()
      body.append('user_id',this.login_user_id)
      body.append('created_by',this.user_email)
      body.append('uploaded_by',this.user_email)
      body.append('file',file)
      body.append('file_name',file.name)
      body.append('style_id',style_id)
      body.append('category_name',category_name)

      // let tempBody = {
      //   "file":file,
      //   "file_name":file.name,
      //   "style_id":style_id,
      //   "category_name":category_name,
      //   "user_id":this.login_user_id,
      //   "created_by":this.user_email,
      //   "uploaded_by":this.user_email,
      // }
      // console.log(tempBody)
      let elementIdentifier = category_name.replace(' ','')
      axios.post(`${CONSTANTS.API_URL}/uploaddesignfiles`,body)
      .then(res=>{
        console.log(res)
        // document.getElementById("overlay").style.display = "none";
        document.getElementById("fileUploadOverlay").style.display = "none"
        if(res.data.returnmsg==="Successful"){
          console.log('isUploaded'+elementIdentifier+style_id)
          if(document.getElementById('isUploaded'+elementIdentifier+style_id) && document.getElementById('downloadLink'+elementIdentifier+style_id)){
            document.getElementById('isUploaded'+elementIdentifier+style_id).style.display="block"
            document.getElementById('downloadLink'+elementIdentifier+style_id).href=res.data.url
            document.getElementById('downloadLink'+elementIdentifier+style_id).style.display="block"
          }
        }else{
          throw new Error()
        }
      })     
      .catch(err=>{
        document.getElementById("fileUploadOverlay").style.display = "none"
        console.log(err)
        this.$fire({
            text:"Error in file upload",
            type: "error",
            timer: 30000
          })
      })
        }else{
          this.$fire({
            text:"Invalid File Format!",
            type: "error",
            timer: 30000
          })
        }
      }
    },

    handleFileUploadModalClose: function(){
      //this.selectedStylesForFileUpload = []
      this.thumbnailsdata(this.pageNo);
    },

    clearSelectedStyles: function(){
      //document.getElementById("overlay").style.display = "block";
      this.selectedStylesForFileUpload = []
      window.location.reload()
      //document.getElementById("overlay").style.display = "none";
    },

    checkCanUploadFiles : function(){
      if(this.user_type ==="Brand_Manager" || this.user_type ==="Buyer"){
        if(this.route_status==="FH_Approved" || this.route_status==="Tech_Pack_Uploaded" || this.route_status==="BOM_Uploaded" || this.route_status==="Measurment_Chart_Uploaded" || this.route_status==="All_Files_Uploaded" || this.route_status==="Designs_Approved"){
          this.canUploadFiles = true
        }else{
          this.canUploadFiles = false
        }
      }else{
        this.canUploadFiles = false
      }
    },
    /************** BOM FUNCTION****************/
    showBomModal: function ()
    {
      const Obj ={
          brand_code: this.brand_id,
          file_type: 'BOM',
      }
      this.isBusy = true;
      axios.post(`${CONSTANTS.API_URL}/gettemplatefiles`, Obj)
        .then(response => {
          this.isBusy = false;
          //this.result = response.data
          if (response.data.returnmsg === 'Successful') {
          
            this.items2 = response.data.returnvalue; 
          
            this.totalRowsBom = response.data.returnvalue.length;
            console.log(response);
          }

          else
          {
            this.items2 = [];
            this.totalRowsBom=0;
          }
        })
      
    },

    selectGrade(){
        this.showGradeModal = true;
    },

    validategrade(){
        console.log("ddddddddddddddddddd",this.selected_Grade)
        this.showGradeModal = false;
    },

    cancelshowGradeModal(){
        this.selected_Grade =  null;
        this.showGradeModal = false;
    }

  }


};
</script>
<style>
.tooltip {
  position: relative;
  display: inline-block;
  /*border-bottom: 1px dotted black;*/
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
.detailsmodalimg{
  height:350px; 
  width:350px; 
  padding:5px;
}
.detailimgborder{
  width:350px;
  float: left;
  border: 1px solid lightgray;
}
.summaryzoombtn{
  padding:5px;
  margin-left: 30%;
  margin-bottom: 10px;
}



@media screen and (max-width: 1040px){
 .summarytableset{
  display: none;
}

}
@media screen and (max-width: 1040px) and (min-width: 992px){
 .summarymodel{
    flex: 0 0 50%;
    max-width: 47%;
}
}
@media screen and (max-width: 990px){
 .summarymodel{
    flex: 0 0 50%;
    max-width: 47%;
}
.designsummaryipad{
   flex: 0 0 90%;
    max-width: 100%;
}
.detailsmodalimg{
  height:180px; 
  width:200px; 
  padding:5px;
}
.detailimgborder{
  width:205px;
  float: left;
  border: 1px solid lightgray;
}
.designsummary{
  margin-top: 10px;
}

}
@media screen and (max-width: 766px) and (min-width: 480px){
 /*.summarymodel{
    flex: 0 0 50%;
    max-width: 47%;
}
.designsummaryipad{
   flex: 0 0 90%;
    max-width: 100%;
}*/
.detailsmodalimg{
  height:150px; 
  width:250px; 
  padding:5px;
}
.detailimgborder{
  width:255px;
  float: left;
  border: 1px solid lightgray;
}
.designsummary{
  margin-top: 10px;
}
.designsummarycol5{
  width:120px ;
}
.designsummarycol1{
  width:10px ;
}

}
@media screen and (max-width: 479px) and (min-width: 350px){
  .summarymodel{
    flex: 0 0 50%;
    max-width: 20%;
}
  .detailsmodalimg{
  height:100px; 
  width:200px; 
  padding:5px;
}
.detailimgborder{
  width:200px;
  float: left;
  border: 1px solid lightgray;
}
.designsummary{
  margin-top: 10px;
  padding-left: 0px;
}
.designsummaryipad{
   font-size:12px;
}
.designsummarycol1{
  width:10px;
}
.designsummarycol5{
  width:115px ;
}
}
@media screen and (max-width: 349px){
  .summarymodel{
    flex: 0 0 50%;
    max-width: 15%;
}
  .detailsmodalimg{
  height:100px; 
  width:150px; 
  padding:5px;
}
.detailimgborder{
  width:150px;
  float: left;
  border: 1px solid lightgray;
}
.designsummary{
  margin-top: 10px;
  padding-left: 0px;
}
.designsummaryipad{
   font-size:11px;
}
.summaryzoombtn{
  padding:5px;
  margin-left: 25%;
  margin-bottom: 10px;
  font-size:10px;
}
.designsummarycol1{
  width:10px;
}
.designsummarycol5{
  width:80px ;
}
}
/*@media screen (min-width: 448px){
  .summarymodel{
    flex: 0 0 50%;
    max-width: 30%;
}
  .detailsmodalimg{
  height:120px; 
  width:220px; 
  padding:5px;
}
.detailimgborder{
  width:225px;
  float: left;
  border: 1px solid lightgray;
}
.designsummary{
  margin-top: 10px;
}
}*/


@media screen and (min-width: 1040px){
 .tablemd{
  display: none;
 }
 }
 @media screen and (max-width: 530px){
 #tablesm{
  display: none;
 }
 }
 @media (min-width: 540px)
{
  .tablechart{
    display:none;
  }

}
@media(max-width: 450px){
  .sumtdhset{
    font-size:10px;
  }
  .sumtdhunit{
    font-size:10px;
  }
  .sumtdhagefrom{
    font-size:10px;
  }
  .sumtdhageto{
    font-size:10px;
  }
  .sumtdhsize{
    font-size:10px;
  }
  .sumtdhquantity{
    font-size:10px;
  }
  .sumtdbquantity{
    width:60px;
  }
  .sumtdbsize{
     width:60px;
  }
  .sumtdbunit{
    padding:0px;
    height: 33px !important;
     width:50px;
  }
   .sumtdbfage{
    padding:0px;
    height: 33px !important;
     width:50px;
  }
  .sumtdbtage{
    padding:0px;
    height: 33px !important;
     width:50px;
  } 
  .detailimgborder{
    margin-top: -26px;
  }


}



/*@media screen and (max-width:360px){
 .card-deck{
  width: 230px;
 }

 .card{
  margin-bottom:0px;
 }

}*/
/*@media screen and (max-width: 320px)
{
.card-deck {
    width: 190px;
}
.card-header{
  font-size:12px;
}
.card-footer{
  font-size:12px;
}
}*/
/*@media screen and (max-width: 300px)
{
.card-deck {
    width: 168px;
}
}*/

/*@media screen and (max-width: 280px)
{
.card-deck {
    width: 160px;
}
.card-header{
  font-size:12px;
}
.card-footer{
  font-size:12px;
}
.ipadsearch{
  padding-right: 0px;
    padding-left: 0px;
    margin-left:10px;
}
}*/
  /*.active, .btn:hover {
  background-color: #666;
  color: white;
}
.btn {
  border: none;
  outline: none;
  padding: 10px 16px;
  background-color: #f1f1f1;
  cursor: pointer;
  font-size: 18px;
}*/
/*@media (min-width: 576px)
{
.card-deck {
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
    height: 400px;
}
}*/

</style>
